import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 640 640">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
         
        >
          <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M348.000000,641.000000 
	C232.000015,641.000000 116.500038,641.000000 1.000046,641.000000 
	C1.000031,427.666718 1.000031,214.333450 1.000015,1.000132 
	C214.333237,1.000088 427.666473,1.000088 640.999756,1.000044 
	C640.999878,214.333191 640.999878,427.666382 640.999939,640.999756 
	C543.500000,641.000000 446.000000,641.000000 348.000000,641.000000 
M527.982178,483.983612 
	C527.982178,483.983612 527.852051,483.892395 528.404480,483.657043 
	C528.509460,483.286194 528.614441,482.915344 528.640259,482.240387 
	C528.640259,482.240387 528.783142,481.960541 529.603149,481.914062 
	C530.233521,481.713226 530.852722,481.461487 531.496033,481.319427 
	C539.003296,479.661407 539.315918,479.647217 538.865723,472.074982 
	C538.640503,468.287781 536.767883,464.627472 536.134338,460.827454 
	C535.508484,457.073395 535.505249,453.215515 535.228882,449.403198 
	C534.761536,449.732635 534.294189,450.062103 533.826904,450.391541 
	C531.881348,449.261444 529.935852,448.131317 528.579285,446.435120 
	C528.719482,444.961426 528.745422,443.466003 529.021057,442.018097 
	C529.900757,437.397400 527.250427,435.115356 523.363892,435.423431 
	C518.580627,435.802551 514.276855,436.285309 511.486877,431.385284 
	C511.368286,431.177094 510.862274,431.063965 510.562256,431.102844 
	C503.021912,432.080841 495.063873,428.527649 487.799957,433.316315 
	C486.928558,433.890808 484.877808,432.983795 483.506989,432.432159 
	C480.205109,431.103394 476.955841,429.102478 473.073181,432.998962 
	C467.434082,433.175079 461.715851,431.893158 456.868286,436.841064 
	C454.108887,439.657562 450.717590,437.959900 448.467865,434.785583 
	C447.766510,433.796051 446.911896,432.232269 446.030029,432.162476 
	C439.457855,431.642242 432.804443,430.751190 426.286377,431.294464 
	C417.962402,431.988251 416.535736,431.088409 417.854950,422.926788 
	C418.607239,418.272522 417.644470,417.202667 411.817627,417.194550 
	C408.210480,417.149933 404.603363,417.105286 400.988617,416.273560 
	C400.183014,411.620453 396.288513,412.147797 393.232910,412.082642 
	C383.128540,411.867157 373.009308,411.762909 362.910156,412.077881 
	C355.168396,412.319305 347.235931,412.766449 343.668579,421.737091 
	C343.141418,423.062683 342.127655,424.821686 340.978638,425.161469 
	C336.649872,426.441589 336.800873,429.628510 336.261108,433.009521 
	C335.301727,433.821594 334.342346,434.633698 333.382965,435.445801 
	C334.002411,435.903839 334.621826,436.361908 335.241272,436.819946 
	C335.827515,435.546631 336.413757,434.273315 337.836792,432.999542 
	C343.542786,431.729706 342.505890,436.939178 344.424194,439.753082 
	C345.088409,438.590637 345.027344,437.479645 345.327667,436.476959 
	C345.658325,435.373016 346.096893,433.681854 346.874329,433.427979 
	C353.953796,431.115997 360.980408,432.585754 367.949463,434.231873 
	C368.631744,434.393005 369.593140,435.214874 369.663574,435.818848 
	C370.060181,439.220764 370.649689,442.684692 370.372803,446.061859 
	C369.888489,451.968872 368.183899,457.822937 368.135132,463.708679 
	C368.035492,475.732178 368.687683,487.762177 369.065521,499.788422 
	C369.084900,500.405457 369.435394,501.012115 369.602570,501.532867 
	C383.657593,504.282806 383.657593,504.282806 387.907257,497.045227 
	C390.305695,496.599182 392.716064,495.727295 395.100189,495.793854 
	C400.408539,495.942047 405.703766,496.559479 411.751373,496.994354 
	C412.498535,497.008942 413.245728,497.023529 414.084045,497.674255 
	C414.731140,498.111176 415.378204,498.548126 416.618439,499.421326 
	C421.917694,502.607208 427.054291,503.213989 432.761444,499.845459 
	C438.036926,496.731689 443.644470,492.719727 450.001221,498.808502 
	C450.476501,500.822479 450.951752,502.836426 451.270874,504.188721 
	C454.439301,504.188721 456.902985,503.852966 459.233582,504.266724 
	C462.814758,504.902405 464.456055,503.424347 464.990295,500.130798 
	C465.183502,498.939575 465.326813,497.740265 465.526794,496.300537 
	C469.675385,498.346832 469.322266,501.388824 468.587280,504.577423 
	C467.710144,508.382812 466.865845,512.195740 466.004608,516.668701 
	C466.005096,517.110840 466.005585,517.552979 465.983673,518.830872 
	C465.741760,519.788269 465.463440,520.738098 465.263885,521.704224 
	C463.967194,527.982422 464.772308,528.991760 471.063599,528.998596 
	C474.378571,529.002136 477.693573,528.991821 481.681976,528.989075 
	C482.452118,528.657776 483.222260,528.326416 484.843567,527.997803 
	C486.173340,528.041016 487.504120,528.137634 488.832672,528.113281 
	C490.352264,528.085510 492.970276,528.349243 493.175171,527.784241 
	C493.718048,526.287415 493.437775,524.364441 493.078491,522.698669 
	C492.568024,520.331787 491.693970,518.043335 490.975250,515.721375 
	C491.446014,515.543762 491.916809,515.366150 492.387573,515.188538 
	C493.374512,516.786682 494.361450,518.384888 495.500946,520.230164 
	C497.079346,516.426514 498.487518,513.101074 499.813660,509.743256 
	C499.963959,509.362732 499.692230,508.787445 499.548737,508.323303 
	C497.996948,503.303833 499.068970,502.399384 504.538239,503.229065 
	C507.025146,503.606293 509.813049,503.434509 512.194519,502.670410 
	C514.603577,501.897461 517.419128,500.411377 515.106323,496.508240 
	C515.387573,496.331573 515.668762,496.154907 516.396545,495.869324 
	C516.687439,495.732147 516.891479,495.513855 517.527039,494.991974 
	C517.897583,494.943909 518.268188,494.895813 519.326660,494.986877 
	C520.551941,495.322968 521.777161,495.659027 523.750427,495.987030 
	C525.444092,494.261017 527.137756,492.535034 528.831482,490.809052 
	C527.895813,490.201233 526.960083,489.593414 525.402893,488.955688 
	C525.195618,488.948273 524.988342,488.940887 524.948853,488.291748 
	C525.636475,487.196045 526.324158,486.100311 527.472290,484.778656 
	C527.606567,484.474518 527.740784,484.170349 527.982178,483.983612 
M368.605347,284.124695 
	C368.507599,284.779999 368.409882,285.435333 368.178619,286.801483 
	C368.206940,287.518372 368.235229,288.235229 367.580414,289.038818 
	C366.804321,290.942841 365.489380,292.830902 365.432465,294.756195 
	C365.391266,296.150085 367.018860,297.593353 368.072357,299.359619 
	C368.072357,299.359619 368.147125,299.736969 368.086395,300.550385 
	C368.550018,301.312775 368.870880,302.572662 369.501373,302.753571 
	C372.651825,303.657654 375.883545,304.278717 379.134827,305.734253 
	C378.946838,307.750214 379.003601,309.827087 378.520142,311.769501 
	C377.504669,315.849213 375.815491,319.796692 375.165100,323.918762 
	C374.758453,326.496002 374.390839,328.299286 371.635529,329.064331 
	C369.772888,329.581604 368.020325,330.495483 365.709961,331.439789 
	C366.920166,332.718384 368.009369,333.869141 368.982300,335.600159 
	C368.675110,336.081360 368.367889,336.562561 367.301025,337.008728 
	C366.540619,337.018005 365.780212,337.027283 364.589783,336.493805 
	C357.807312,336.833710 352.601410,342.501953 353.997803,348.843292 
	C354.003693,350.225372 354.009552,351.607422 353.870026,353.724854 
	C353.063324,354.173981 352.304840,354.798065 351.440063,355.036499 
	C349.535645,355.561462 347.090363,355.304413 345.742157,356.422913 
	C342.877258,358.799591 339.199860,360.147522 340.815979,366.236237 
	C341.827698,370.047943 341.416107,374.898438 342.989807,379.052460 
	C343.429138,380.212067 344.772003,381.693176 345.859497,381.838837 
	C354.887604,383.048035 363.958771,383.930420 373.005402,385.008484 
	C380.467834,385.897736 387.908966,386.967010 395.373688,387.834717 
	C396.624146,387.980103 397.970795,387.604187 399.231079,387.297058 
	C402.159149,386.583496 405.098511,385.878448 407.961456,384.948669 
	C409.861023,384.331848 411.644073,383.349030 413.465546,382.500549 
	C416.313873,381.173737 419.034088,379.356812 422.024078,378.608337 
	C425.170105,377.820831 428.569427,378.044983 432.508118,377.784027 
	C431.426453,375.753815 430.268646,374.128662 430.489349,373.912811 
	C433.895294,370.581146 431.472137,366.317719 432.461060,362.874542 
	C433.745880,358.400970 431.927704,355.958832 428.893097,354.323547 
	C427.088623,353.351166 424.332153,354.145447 421.778992,354.145447 
	C420.486053,353.279144 418.763458,352.124969 417.026459,350.139160 
	C417.731812,345.420898 415.432648,343.664459 411.010101,343.244110 
	C412.873871,341.438904 414.737640,339.633667 416.333466,338.087982 
	C412.797058,336.694366 409.388611,335.351227 405.954102,333.243469 
	C405.726898,332.652863 405.598511,331.613129 405.257904,331.538269 
	C399.091766,330.182007 397.321899,325.642914 396.037048,320.134766 
	C394.907562,315.292908 392.673859,310.708618 391.419678,305.444885 
	C393.971832,305.126373 396.520721,304.777740 399.076996,304.496857 
	C402.421570,304.129364 405.355133,303.367615 405.087372,298.355286 
	C405.203217,296.839233 405.485748,295.311829 405.383209,293.810699 
	C405.298279,292.567749 404.458649,291.353088 404.470032,290.130707 
	C404.541870,282.415161 404.757874,274.700958 405.041718,266.247070 
	C405.173004,265.138916 405.648285,263.936951 405.376129,262.938812 
	C404.190948,258.592712 402.742645,254.319046 401.493408,249.989227 
	C401.134125,248.743988 401.269684,247.357422 400.921204,246.107361 
	C399.962067,242.667114 399.202515,239.109711 397.718079,235.897095 
	C396.548065,233.364883 394.738068,230.884232 392.595367,229.137527 
	C391.319366,228.097351 388.850891,228.519958 386.349487,228.120605 
	C385.887878,227.766998 385.426300,227.413376 384.985168,226.309341 
	C382.913086,224.477371 381.055756,221.436264 378.731598,221.023529 
	C368.859741,219.270309 358.880341,217.740128 348.881592,217.185608 
	C337.613892,216.560715 326.283234,217.070816 314.932770,216.545227 
	C314.912811,216.365677 314.892853,216.186111 314.930481,215.306137 
	C314.282410,214.556549 313.634308,213.806961 312.982574,212.373199 
	C312.960327,211.917770 312.938080,211.462341 313.047302,210.219177 
	C315.168243,204.174377 317.306946,198.135483 319.324646,192.056412 
	C319.385529,191.873032 318.181152,191.269714 317.782257,190.243042 
	C317.968018,189.851196 318.153778,189.459366 319.031311,188.857620 
	C318.890656,186.055588 319.232269,183.121262 318.507538,180.479446 
	C317.060913,175.206253 311.785004,181.626144 309.474426,177.864731 
	C310.550720,176.189774 315.461151,177.923218 313.515900,173.501984 
	C313.515900,173.501984 313.567719,173.393387 314.269440,173.718307 
	C315.745605,172.984085 317.221771,172.249863 319.654510,171.039856 
	C317.166565,169.711731 315.576202,168.862762 313.540558,167.804459 
	C313.286011,167.583008 313.107361,167.311584 313.020233,166.247467 
	C311.642700,165.031601 310.081879,162.625061 308.919067,162.804047 
	C303.619293,163.619888 303.774536,159.365860 303.119751,156.644119 
	C302.279236,153.150314 304.266754,151.287338 308.090393,150.860458 
	C311.461426,150.484100 314.740997,149.223236 318.038422,148.274536 
	C320.474884,147.573563 322.828339,146.452377 325.304657,146.059021 
	C327.741943,145.671875 330.335663,146.277649 332.776001,145.900040 
	C339.082520,144.924255 343.347748,142.175339 343.312286,135.408905 
	C343.285675,130.335999 340.325104,128.623260 337.598633,126.104179 
	C334.533081,123.271805 331.371063,121.713158 326.623810,122.448898 
	C320.475403,123.401794 314.334564,125.323524 307.711151,122.272026 
	C302.319000,119.787796 295.790497,118.053413 289.995300,118.568283 
	C281.579742,119.315948 273.405548,122.548950 265.048950,124.354134 
	C262.960602,124.805237 259.778748,124.657700 258.471802,123.380760 
	C255.246979,120.229973 251.946228,121.648117 248.395996,121.520996 
	C242.009521,121.292328 240.317291,126.075302 238.338684,130.079742 
	C236.387543,134.028671 236.195969,138.440506 240.336151,141.829407 
	C243.605392,144.505402 246.464310,147.762146 249.981079,150.020187 
	C251.562759,151.035751 255.772797,151.056183 256.278992,150.140274 
	C259.325287,144.628418 262.511414,147.439117 266.292999,148.895874 
	C268.920807,149.908157 272.174652,153.037735 275.685547,148.900635 
	C276.099274,149.038116 276.512970,149.175613 277.105713,149.956848 
	C280.647766,153.997955 280.271729,159.772476 276.674957,161.750977 
	C273.450989,163.524429 270.349487,165.669113 267.592102,168.101395 
	C264.694977,170.656921 264.101379,173.340790 268.692780,175.144791 
	C269.886047,175.613632 270.731110,176.968704 271.865570,178.038803 
	C269.166138,180.207230 263.482941,176.934036 264.056458,182.988586 
	C264.056458,182.988586 264.138336,183.118561 263.365509,183.095093 
	C259.875854,184.809219 260.382141,187.286896 262.161041,190.707047 
	C266.564789,194.868530 264.904846,200.276489 264.964081,205.230103 
	C265.115875,217.925262 262.982941,219.459869 250.075882,216.558334 
	C249.433334,216.413864 248.799179,216.109238 248.158142,216.100647 
	C244.077576,216.045883 239.955078,215.717896 235.935898,216.210480 
	C234.393372,216.399521 233.013138,218.440582 231.758301,219.819214 
	C231.590637,220.003387 232.599899,221.258850 233.155777,222.949738 
	C233.069885,234.321915 232.983994,245.694107 232.057663,257.008392 
	C231.328293,258.213867 229.835464,259.534180 229.996658,260.605682 
	C230.873718,266.436340 237.109360,266.795563 242.879776,263.234222 
	C244.253922,263.156982 245.628082,263.079742 247.302536,263.627747 
	C248.160568,263.997864 249.484863,264.925385 249.807556,264.655487 
	C255.863388,259.590057 262.688568,261.020599 269.570740,261.874268 
	C272.076660,262.185120 273.019440,262.883148 273.115326,265.433319 
	C273.185059,267.286713 273.471588,269.802368 274.676849,270.819061 
	C278.548737,274.085114 282.891907,276.792480 286.686279,279.457550 
	C288.756989,278.926117 290.759003,277.684174 292.121155,278.184448 
	C299.335175,280.833954 305.970917,278.919739 312.342407,275.883545 
	C314.709900,274.755371 316.132904,271.685852 318.487762,270.481720 
	C322.826782,268.263031 324.814392,264.978577 326.185425,260.404236 
	C329.194519,250.364868 331.569702,249.056824 342.505249,248.918259 
	C344.353180,248.894852 346.191986,248.153748 348.665039,247.930527 
	C349.096771,248.001694 349.528534,248.072845 349.997894,248.900360 
	C350.165771,250.085312 350.333618,251.270248 350.570526,252.942398 
	C352.766449,251.506439 354.447815,250.406982 356.803192,249.458176 
	C357.523926,250.000870 358.244629,250.543564 358.972504,251.833908 
	C360.090057,253.976288 361.290497,256.080170 362.307587,258.269226 
	C364.315857,262.591583 367.575043,266.244476 366.365906,271.947296 
	C365.717285,275.006500 367.979767,278.682861 368.958527,282.779327 
	C369.057251,283.234039 369.156006,283.688721 369.183533,284.184387 
	C369.183533,284.184387 369.259796,284.214844 368.605347,284.124695 
M184.000168,487.661957 
	C184.012390,488.105927 184.024612,488.549866 183.395508,489.300842 
	C181.187012,491.107330 178.540833,493.265228 180.724304,496.070892 
	C181.419479,496.964172 185.180923,495.471466 187.539154,495.069641 
	C187.700684,495.042114 187.860901,495.006836 188.000000,494.998779 
	C188.000000,494.998779 188.021851,494.978302 188.089432,495.631531 
	C188.741684,496.078217 189.393951,496.524933 190.767700,497.059113 
	C195.686996,499.027954 200.509506,501.309357 205.554733,502.871521 
	C209.970016,504.238617 214.032623,503.750519 217.047592,499.155792 
	C218.804535,496.478210 222.563919,495.450775 224.794785,498.146454 
	C228.659332,502.816132 233.384155,500.484497 237.772797,500.677734 
	C238.346054,500.702972 239.016647,498.517212 239.793167,497.123077 
	C239.793167,497.123077 240.041550,497.000061 240.817810,496.832367 
	C241.198776,495.146057 241.978226,493.440155 241.896317,491.776642 
	C241.342758,480.533936 240.993713,469.257233 239.752045,458.083374 
	C239.206284,453.171844 237.949600,447.377441 234.853851,443.919159 
	C229.095963,437.487000 221.876266,432.179932 211.256500,433.987061 
	C210.504303,432.799103 209.142105,431.626892 209.110977,430.420349 
	C209.005478,426.328613 207.006927,424.788818 203.165314,424.989502 
	C201.848145,425.058319 200.512070,425.116943 199.205887,424.978912 
	C194.890411,424.522919 192.643250,426.886719 193.158356,430.715149 
	C193.719711,434.887329 192.688629,438.088104 189.574188,441.238007 
	C189.300751,441.429108 189.118454,441.685150 188.219543,441.998718 
	C187.226471,441.625305 185.381088,441.279602 185.367935,440.874359 
	C185.164520,434.608307 181.362915,434.849426 176.688095,435.384247 
	C175.320450,433.397095 174.103119,431.283417 172.556824,429.446686 
	C168.005203,424.040466 163.364975,417.827423 155.964661,417.248596 
	C142.320053,416.181458 128.578354,416.311279 114.874626,416.117371 
	C113.589714,416.099182 112.287163,417.327850 111.003349,417.998016 
	C111.003349,417.998016 110.981598,417.995361 110.253799,418.121185 
	C107.701080,421.569183 107.949646,425.486694 107.977440,429.522766 
	C108.116035,449.643005 108.043594,469.764740 108.045433,489.885925 
	C108.046181,498.015289 109.896744,499.878082 118.274963,499.946777 
	C125.003082,500.001953 131.737167,500.075806 138.456207,499.817993 
	C139.689789,499.770660 140.863953,498.174103 142.872559,497.134338 
	C144.243088,497.076050 145.613602,497.017761 147.425797,497.502502 
	C150.257050,497.319153 153.088303,497.135803 156.797729,496.987030 
	C159.016846,496.298187 162.875107,498.977936 163.680542,493.892029 
	C166.766876,491.248260 169.853210,488.604523 173.647278,486.053772 
	C175.210129,486.953156 176.772980,487.852570 178.335831,488.751953 
	C178.689987,488.281494 179.044144,487.811035 179.398315,487.340576 
	C177.589737,485.893158 175.781174,484.445770 174.262192,482.295715 
	C174.844727,479.864197 175.427261,477.432709 176.653473,474.915558 
	C177.091293,474.265289 177.529114,473.614990 177.982254,472.973724 
	C177.982254,472.973724 177.958694,472.958710 178.680298,472.994446 
	C180.125778,473.663635 181.571274,474.332825 183.061310,475.674255 
	C183.037323,477.448761 183.013351,479.223297 182.294449,481.009888 
	C181.867615,481.784515 180.890091,482.844269 181.116119,483.280884 
	C181.822800,484.645844 182.983963,485.775513 184.000168,487.661957 
M298.683655,440.582733 
	C298.130615,440.742584 297.577576,440.902405 296.664795,440.369537 
	C294.006317,439.835144 291.347839,439.300720 287.657013,438.558777 
	C288.802277,441.696716 289.405090,443.348267 289.904907,445.749481 
	C286.694550,451.496338 293.152435,452.251709 294.464294,455.064545 
	C296.891479,454.653351 298.963348,454.436493 300.961243,453.928711 
	C303.278290,453.339844 306.129547,453.126465 307.694977,451.640106 
	C311.882172,447.664307 316.330353,447.821777 319.020386,452.408417 
	C321.149963,452.625854 323.055023,452.820374 325.310699,453.614899 
	C325.436798,454.058319 325.562866,454.501740 324.846161,455.011047 
	C323.951599,456.712433 323.057037,458.413818 322.701447,459.090118 
	C316.411987,459.090118 310.502991,458.959534 304.612366,459.229279 
	C303.716736,459.270294 302.906158,461.168060 301.455353,462.494202 
	C301.022705,462.588257 300.590027,462.682312 299.895935,462.019318 
	C294.003815,460.015900 290.828430,464.715088 288.346863,468.052673 
	C285.407990,472.005310 284.338287,477.347687 282.183350,482.781311 
	C282.036530,482.757294 280.811005,482.479950 279.570892,482.375336 
	C278.276978,482.266113 276.881256,482.017670 275.682800,482.361908 
	C271.093475,483.680267 268.919556,482.431244 269.045807,477.681000 
	C269.287262,468.595154 266.975830,459.143677 272.883881,450.707977 
	C274.038055,450.098206 275.529114,449.310394 277.529846,448.255127 
	C277.873901,448.089478 278.217957,447.923828 279.345398,447.823669 
	C283.011688,443.874054 282.861847,441.399628 278.959045,439.010803 
	C278.959045,439.010803 278.847321,439.167572 278.908447,438.466797 
	C278.798004,437.014435 278.687592,435.562073 278.575989,434.094330 
	C269.635956,433.900787 269.739258,433.890747 268.868713,424.929932 
	C268.733002,423.532928 267.164520,422.275146 266.049255,420.350647 
	C265.941559,419.939636 265.833862,419.528595 266.295227,418.707611 
	C264.150635,416.243164 261.711304,416.296356 258.317383,418.985382 
	C257.883087,418.937897 257.448792,418.890411 256.834198,418.529510 
	C256.551697,418.617126 256.269196,418.704712 255.330307,418.958618 
	C254.556702,419.640839 253.783081,420.323059 252.266434,421.138885 
	C251.167877,425.467712 250.069321,429.796509 248.970764,434.125336 
	C246.737213,435.752716 244.601990,437.775757 243.569656,440.257568 
	C242.712021,442.319366 242.905746,444.940887 243.095795,447.276855 
	C243.244003,449.098480 244.102203,450.862366 244.644882,452.651886 
	C246.037170,451.847107 247.429443,451.042358 249.463730,449.866486 
	C249.679245,451.496490 250.008514,452.847687 250.012894,454.199921 
	C250.048355,465.160583 250.026321,476.121490 250.008804,487.082306 
	C250.007507,487.891205 249.629120,488.804871 249.890915,489.492981 
	C253.362839,498.619324 261.094696,502.939362 270.409210,501.098175 
	C271.202209,500.941406 272.071106,501.009521 272.882050,501.128326 
	C278.802765,501.995422 279.946808,501.210297 282.148193,494.389099 
	C282.271179,494.269684 282.394165,494.150238 283.238678,494.044830 
	C286.925690,495.222260 291.095734,495.667694 294.205719,497.719666 
	C302.300537,503.060669 310.661499,501.566711 319.134521,499.814484 
	C319.866089,499.663208 320.273956,497.946686 321.592041,496.886780 
	C324.094482,495.681000 326.604095,493.441132 329.348633,497.684052 
	C329.742706,499.267548 330.136780,500.851013 330.582520,502.642181 
	C331.751801,502.755463 332.879822,502.937622 334.011322,502.963013 
	C344.679993,503.202271 345.287048,502.802185 344.904877,491.848846 
	C344.635590,484.131470 343.145203,476.443115 343.086792,468.735107 
	C342.996124,456.763062 341.349304,446.105225 330.378326,438.418030 
	C326.624939,435.788055 323.606415,433.644958 319.006500,433.987061 
	C314.553284,434.318329 309.987427,433.866394 305.646454,434.686584 
	C303.242065,435.140869 301.196930,437.496490 298.994537,439.572968 
	C299.019775,439.763916 299.045044,439.954834 298.683655,440.582733 
M371.811096,508.802917 
	C370.271667,510.120972 369.469604,511.798248 372.060211,512.347900 
	C374.922668,512.955261 377.974426,512.870361 380.924103,512.714600 
	C381.594849,512.679138 382.746887,511.046692 382.656219,510.268188 
	C382.562531,509.463867 381.265381,508.245880 380.424316,508.185181 
	C377.797363,507.995667 375.137146,508.267487 371.811096,508.802917 
M297.635895,502.473419 
	C297.844025,502.526337 298.052124,502.579285 298.260254,502.632233 
	C298.127167,502.503143 297.994049,502.374054 297.635895,502.473419 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M412.681335,417.177795 
	C417.644470,417.202667 418.607239,418.272522 417.854950,422.926788 
	C416.535736,431.088409 417.962402,431.988251 426.286377,431.294464 
	C432.804443,430.751190 439.457855,431.642242 446.030029,432.162476 
	C446.911896,432.232269 447.766510,433.796051 448.467865,434.785583 
	C450.717590,437.959900 454.108887,439.657562 456.868286,436.841064 
	C461.715851,431.893158 467.434082,433.175079 473.537903,433.000854 
	C474.002655,433.002777 474.009766,433.010376 474.005310,433.423645 
	C474.009613,439.725494 468.440094,435.257904 467.257568,436.920227 
	C468.296722,440.723511 469.316162,443.796417 469.965363,446.945679 
	C472.660828,460.020996 468.431976,473.168030 470.696045,486.432983 
	C472.236084,495.455872 470.948181,504.954407 471.027466,514.239380 
	C471.043915,516.165894 471.512817,518.088623 471.933228,520.244141 
	C472.394714,520.693787 472.696167,520.912415 473.048706,521.503845 
	C474.239594,525.284729 474.766602,530.195251 479.606659,524.515198 
	C479.795868,524.293152 480.180420,524.173889 480.491577,524.129089 
	C485.466919,523.412964 487.894287,520.110229 488.302704,515.530029 
	C488.446045,513.922302 486.611542,512.223755 486.073792,510.447540 
	C485.435333,508.338715 485.221375,506.101410 484.780884,503.488647 
	C484.795746,501.036438 484.853088,499.015350 485.333252,496.996918 
	C488.164185,497.167511 490.344177,497.036560 490.406250,493.807922 
	C492.884155,495.114014 495.033081,496.312683 497.137756,497.965332 
	C497.236908,499.040497 497.355713,500.196991 497.527191,500.204834 
	C502.358337,500.426331 507.195435,500.583984 512.028625,500.522095 
	C512.306702,500.518555 512.559875,498.572052 513.030579,497.348389 
	C513.766663,497.087708 514.296814,497.008484 514.826965,496.929230 
	C517.419128,500.411377 514.603577,501.897461 512.194519,502.670410 
	C509.813049,503.434509 507.025146,503.606293 504.538239,503.229065 
	C499.068970,502.399384 497.996948,503.303833 499.548737,508.323303 
	C499.692230,508.787445 499.963959,509.362732 499.813660,509.743256 
	C498.487518,513.101074 497.079346,516.426514 495.500946,520.230164 
	C494.361450,518.384888 493.374512,516.786682 492.387573,515.188538 
	C491.916809,515.366150 491.446014,515.543762 490.975250,515.721375 
	C491.693970,518.043335 492.568024,520.331787 493.078491,522.698669 
	C493.437775,524.364441 493.718048,526.287415 493.175171,527.784241 
	C492.970276,528.349243 490.352264,528.085510 488.832672,528.113281 
	C487.504120,528.137634 486.173340,528.041016 484.282654,527.711182 
	C483.351135,526.505737 482.980530,525.586975 482.609924,524.668213 
	C482.140259,525.033813 481.670624,525.399475 481.200958,525.765137 
	C481.136841,526.839355 481.072693,527.913574 481.008545,528.987793 
	C477.693573,528.991821 474.378571,529.002136 471.063599,528.998596 
	C464.772308,528.991760 463.967194,527.982422 465.263885,521.704224 
	C465.463440,520.738098 465.741760,519.788269 466.353058,518.450745 
	C471.999634,519.714233 469.414673,515.888245 469.918671,514.012756 
	C468.441498,514.765320 467.224426,515.385376 466.007324,516.005432 
	C466.865845,512.195740 467.710144,508.382812 468.587280,504.577423 
	C469.322266,501.388824 469.675385,498.346832 465.526794,496.300537 
	C465.326813,497.740265 465.183502,498.939575 464.990295,500.130798 
	C464.456055,503.424347 462.814758,504.902405 459.233582,504.266724 
	C456.902985,503.852966 454.439301,504.188721 451.270874,504.188721 
	C450.951752,502.836426 450.476501,500.822479 450.390778,498.298340 
	C451.034302,497.696808 451.288300,497.605438 451.931519,497.578003 
	C455.418732,497.268921 459.363464,499.730225 461.445251,494.828796 
	C463.694214,492.252655 465.526093,489.860382 461.064880,487.743164 
	C460.911041,487.112915 460.844086,486.747772 460.841919,485.983398 
	C460.598969,484.058533 460.291168,482.532928 460.283539,480.715637 
	C460.716522,476.053070 460.947601,471.680939 460.890869,467.312561 
	C460.880768,466.533447 459.677521,465.769775 459.019287,464.599213 
	C459.015533,463.133270 459.017639,462.067139 459.364380,460.938904 
	C461.663849,459.186615 461.766479,457.832977 458.995544,456.624878 
	C458.751740,455.288574 458.347015,454.334167 458.308319,453.365143 
	C457.959229,444.618225 452.927551,439.454193 444.040649,438.571777 
	C443.380707,437.630157 442.796814,437.001404 442.212891,436.372681 
	C441.809906,436.904602 441.406891,437.436523 440.674438,437.954956 
	C439.913361,437.867645 439.481689,437.793823 438.920166,437.350952 
	C434.435028,435.850494 430.071899,434.574249 425.634918,437.774963 
	C424.898651,437.943665 424.471588,438.010315 423.816467,437.788544 
	C420.579346,438.020355 417.437469,438.177826 414.615845,439.210327 
	C413.154663,439.745026 412.260925,441.830261 410.892456,443.460449 
	C410.177399,444.788452 409.680725,445.870972 408.909851,447.127441 
	C409.449646,448.523682 410.263702,449.746033 411.236755,451.221191 
	C412.234833,451.888458 413.073883,452.302887 414.070618,453.006592 
	C415.152069,452.527252 416.075806,451.758575 417.240601,450.891174 
	C417.825958,450.760956 418.170197,450.729431 418.921021,450.783081 
	C421.565063,449.647858 423.802521,448.427490 426.431152,447.137268 
	C427.880371,447.033081 428.938416,446.998779 430.068573,447.338745 
	C433.877136,448.750244 437.613617,449.787445 441.641022,450.910156 
	C442.350067,451.641266 442.768127,452.286896 442.891785,453.136200 
	C443.386902,455.233185 444.176422,457.126495 445.020782,459.346436 
	C445.055359,460.113342 445.035095,460.553558 444.637756,460.995789 
	C443.154755,461.379974 442.048798,461.762207 440.618042,462.111420 
	C439.866241,461.997040 439.439270,461.915710 438.861664,461.574585 
	C437.789551,461.277618 436.868103,461.240448 435.491516,461.207031 
	C431.172180,461.221100 427.308014,461.231384 423.147736,461.240540 
	C422.566986,461.491455 422.282288,461.743530 421.657166,462.071075 
	C420.391235,462.217651 419.465698,462.288757 418.176208,462.278137 
	C417.207458,462.789185 416.602692,463.381989 415.830139,464.056824 
	C415.662354,464.138855 415.290314,464.172211 414.854645,464.115112 
	C410.597656,463.539215 408.445496,464.816345 409.027039,469.023804 
	C409.009735,468.994293 409.061432,469.040100 408.715454,469.070374 
	C407.867981,470.034454 407.366455,470.968292 406.637054,472.145630 
	C406.269287,473.255737 406.129364,474.122375 405.905334,475.226990 
	C405.756226,475.620270 405.691284,475.775543 405.286926,476.019409 
	C402.312256,479.363037 403.728760,488.885010 407.297760,491.487091 
	C407.774567,491.834747 408.548981,491.774200 409.471069,491.972534 
	C410.213623,492.622009 410.670654,493.201660 411.074402,494.180145 
	C411.015533,495.381195 411.009949,496.183411 411.004333,496.985657 
	C405.703766,496.559479 400.408539,495.942047 395.100189,495.793854 
	C392.716064,495.727295 390.305695,496.599182 387.480682,497.049011 
	C387.054108,497.052765 386.994110,496.994263 387.029297,496.527161 
	C387.078400,475.410461 387.184326,454.760162 387.025604,434.111908 
	C386.995239,430.163910 388.219513,428.772583 392.147552,428.941315 
	C397.965485,429.191254 403.806824,429.143066 409.626556,428.918549 
	C410.956329,428.867249 413.313782,427.633575 413.354034,426.849365 
	C413.518555,423.645477 412.968353,420.404877 412.681335,417.177795 
M469.483093,496.588440 
	C469.483093,496.588440 469.416382,496.476471 469.483093,496.588440 
M469.517639,489.411560 
	C469.517639,489.411560 469.584412,489.523468 469.517639,489.411560 
z"/>
<path fill="#EAF9FA" opacity="1.000000" stroke="none" 
	d="
M417.040863,350.970764 
	C418.763458,352.124969 420.486053,353.279144 421.778992,354.145447 
	C424.332153,354.145447 427.088623,353.351166 428.893097,354.323547 
	C431.927704,355.958832 433.745880,358.400970 432.461060,362.874542 
	C431.472137,366.317719 433.895294,370.581146 430.489349,373.912811 
	C430.268646,374.128662 431.426453,375.753815 432.508118,377.784027 
	C428.569427,378.044983 425.170105,377.820831 422.024078,378.608337 
	C419.034088,379.356812 416.313873,381.173737 413.465546,382.500549 
	C411.644073,383.349030 409.861023,384.331848 407.961456,384.948669 
	C405.098511,385.878448 402.159149,386.583496 399.231079,387.297058 
	C397.970795,387.604187 396.624146,387.980103 395.373688,387.834717 
	C387.908966,386.967010 380.467834,385.897736 373.005402,385.008484 
	C363.958771,383.930420 354.887604,383.048035 345.859497,381.838837 
	C344.772003,381.693176 343.429138,380.212067 342.989807,379.052460 
	C341.416107,374.898438 341.827698,370.047943 340.815979,366.236237 
	C339.199860,360.147522 342.877258,358.799591 345.742157,356.422913 
	C347.090363,355.304413 349.535645,355.561462 351.440063,355.036499 
	C352.304840,354.798065 353.063324,354.173981 354.312683,353.354553 
	C355.248230,352.956421 355.741089,352.928558 356.470154,353.035522 
	C357.152039,353.735596 357.597717,354.300873 358.129303,355.120087 
	C358.504730,355.568115 358.794250,355.762207 359.043091,355.956238 
	C359.002411,355.956207 359.065979,355.905457 359.077637,356.274841 
	C360.427612,357.414276 361.765930,358.184387 363.426331,359.063416 
	C365.152710,359.925385 366.556976,360.678436 368.033997,361.712280 
	C368.577240,362.270813 369.047791,362.548584 369.630188,362.764191 
	C369.742035,362.701996 369.975616,362.806671 370.122314,363.146545 
	C372.527252,363.953125 374.785553,364.419830 377.374878,364.887756 
	C378.142059,364.949799 378.578217,365.010620 379.225464,365.342957 
	C383.504761,369.549988 388.197479,366.816864 392.492035,366.476379 
	C395.402252,366.245636 398.169220,364.208130 401.133240,362.896729 
	C401.266266,362.814819 401.576813,362.849243 401.868774,362.826202 
	C402.437439,362.547729 402.714081,362.292297 403.146515,361.955017 
	C403.302307,361.873199 403.654297,361.873840 403.938904,361.836548 
	C404.482391,361.533447 404.741241,361.267670 405.148987,360.925964 
	C405.297852,360.850067 405.631561,360.867737 405.924622,360.826904 
	C406.472870,360.502930 406.728088,360.219757 407.156433,359.684113 
	C408.425385,358.899628 409.521210,358.367584 410.996094,357.864777 
	C412.223053,356.891968 413.070953,355.889923 413.951874,354.933807 
	C413.984894,354.979736 413.888184,354.920959 414.251099,354.898987 
	C415.015503,354.114349 415.417023,353.351624 415.800537,352.432251 
	C415.782562,352.275574 415.885712,351.977478 416.132568,351.880890 
	C416.599884,351.513123 416.820374,351.241943 417.040863,350.970764 
M378.959351,382.849945 
	C396.012848,384.459656 411.189545,380.036102 424.283783,368.822021 
	C426.914337,366.569183 429.936035,363.999573 427.297028,360.535004 
	C424.578400,356.965820 421.408112,359.142242 418.789581,361.562958 
	C418.181885,362.124725 417.549255,362.662170 416.902466,363.178711 
	C404.710236,372.915924 390.895630,375.896606 375.681183,373.093262 
	C366.397308,371.382629 358.731079,366.648193 351.575348,360.721527 
	C350.193512,359.576965 347.645905,359.196960 345.809845,359.503815 
	C344.831177,359.667358 343.324921,362.329071 343.645172,363.378510 
	C344.229279,365.292755 345.743774,367.133942 347.309662,368.502869 
	C356.152557,376.233917 366.435486,380.976685 378.959351,382.849945 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M240.041550,497.000061 
	C240.041550,497.000061 239.793167,497.123077 239.312347,497.262695 
	C232.108383,498.603119 227.093338,496.876495 225.905945,489.105804 
	C210.736359,500.952515 200.348358,501.197723 187.389740,490.290100 
	C187.386566,490.146454 187.173340,489.953796 187.156189,489.677856 
	C186.663300,488.664032 186.187561,487.926178 185.627029,486.784241 
	C185.302551,485.590668 185.062866,484.801208 184.896103,483.570862 
	C186.027161,478.457916 187.085312,473.785858 188.104340,469.049072 
	C188.065216,468.984375 188.118835,469.125153 188.432281,469.035339 
	C190.203918,467.669678 191.662109,466.393890 193.053070,465.099304 
	C192.985825,465.080505 193.114212,465.139893 193.484894,465.095215 
	C197.916138,463.759094 201.976685,462.467682 206.470261,461.206268 
	C208.927460,461.186127 210.951630,461.135986 213.249969,461.310699 
	C214.704590,461.576752 215.885056,461.617950 217.371216,461.788269 
	C218.118240,461.938721 218.559570,461.959991 219.273438,462.265106 
	C221.100662,462.762482 222.655319,462.976044 224.673874,463.253296 
	C224.783829,457.961090 225.038071,453.400146 220.340637,450.290466 
	C220.326981,450.146759 220.112610,449.953339 219.960388,449.608765 
	C212.657379,444.822357 202.676666,445.813782 194.448624,451.778137 
	C194.272003,451.790619 193.983353,451.995728 193.608826,451.984161 
	C191.740311,449.638580 190.246353,447.304565 188.891205,444.813904 
	C189.030014,444.657257 189.168106,444.262054 189.518982,444.185486 
	C197.297501,439.623779 205.248047,437.507874 214.020233,437.778412 
	C227.938797,438.207733 236.722092,446.698761 236.907913,460.546509 
	C237.017029,468.678192 237.080811,476.810486 236.764923,484.953735 
	C235.343079,483.830017 233.447403,482.699799 233.441299,481.559448 
	C233.401428,474.109589 233.977371,466.656647 233.944382,459.206512 
	C233.915344,452.650330 227.107178,442.475708 222.529678,442.050629 
	C216.105179,441.453949 209.639954,441.124756 203.189957,441.090088 
	C201.506210,441.081024 199.814331,442.586548 198.126190,443.396454 
	C202.265030,444.006683 205.716156,444.111908 209.156311,443.963379 
	C210.946548,443.886108 212.852982,442.767944 214.474289,443.138306 
	C222.674393,445.011475 226.182663,451.273254 227.774582,458.767334 
	C228.157806,460.571472 227.589630,463.635712 226.332794,464.520203 
	C223.278336,466.669861 224.371155,468.242767 225.647400,470.702606 
	C229.353760,477.846191 228.777496,481.081055 224.169403,485.599792 
	C227.987289,488.907166 231.871948,492.272339 236.497498,496.279388 
	C236.797226,492.433594 237.066422,488.979736 237.709061,485.668701 
	C242.045380,488.961517 239.126373,493.316467 240.041550,497.000061 
M221.995636,470.280701 
	C215.473938,468.584534 208.948822,467.550293 202.486099,470.480255 
	C198.880875,472.114716 196.593140,474.681976 196.697601,478.921326 
	C196.802933,483.195740 198.806686,486.089813 202.671738,487.891235 
	C209.450607,491.050659 220.769104,487.455750 223.885742,480.580261 
	C225.327057,477.400635 226.317429,473.549377 221.995636,470.280701 
M201.343079,495.586426 
	C203.731262,495.586426 206.119446,495.586426 208.507629,495.586426 
	C208.599396,495.070892 208.691177,494.555389 208.782959,494.039856 
	C205.399460,492.593048 201.930588,491.311462 198.670181,489.626465 
	C197.147095,488.839294 195.641205,487.493225 194.795074,486.017700 
	C191.954651,481.064545 194.254715,472.307068 199.034821,469.011688 
	C200.548355,467.968292 202.110825,466.995850 204.687515,465.314484 
	C202.108154,465.194244 200.315582,464.566040 199.664322,465.169525 
	C195.704590,468.838837 191.298019,472.329956 188.414993,476.772522 
	C185.475815,481.301544 187.079315,485.804443 191.584915,489.310577 
	C194.409302,491.508362 197.631851,493.194489 201.343079,495.586426 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M276.926697,149.313095 
	C276.512970,149.175613 276.099274,149.038116 275.093048,148.646820 
	C267.294403,145.368515 259.995636,143.232559 252.004883,144.906326 
	C250.345581,145.253860 248.352295,144.636108 246.655136,144.050842 
	C242.286102,142.544205 239.922256,138.431885 240.527939,133.842804 
	C241.596481,125.746925 249.401810,121.294357 256.926086,125.543640 
	C262.494507,128.688370 266.543152,127.685326 271.959900,125.390808 
	C285.485474,119.661430 299.231476,119.478561 312.056824,127.749374 
	C315.138428,129.736664 317.178345,129.542389 320.020508,127.586479 
	C325.465668,123.839272 331.029266,124.072281 335.773376,127.718506 
	C342.025848,132.524048 341.148438,140.126892 333.826935,142.966339 
	C331.420227,143.899719 328.575562,144.501373 326.057098,144.200455 
	C318.287933,143.272171 311.368622,146.361954 304.218231,148.286484 
	C302.723694,148.688721 300.876404,150.201965 300.412018,151.606674 
	C297.889465,159.236618 300.086060,163.066803 307.791595,165.355392 
	C309.537140,165.873825 311.267395,166.443893 313.004669,166.990173 
	C313.107361,167.311584 313.286011,167.583008 313.790344,168.310211 
	C313.882660,170.341766 313.725189,171.867584 313.567719,173.393387 
	C313.567719,173.393387 313.515900,173.501984 313.111145,173.576553 
	C301.340698,178.204834 289.611877,178.552277 277.879486,175.856384 
	C274.701782,175.126190 271.999176,172.328217 269.078522,170.479340 
	C271.966522,168.606934 274.641876,166.162628 277.790710,164.991745 
	C282.937561,163.077896 283.299652,162.576431 282.872559,153.499557 
	C282.666809,149.127335 279.581604,149.734497 276.926697,149.313095 
M283.605133,166.709244 
	C280.258331,167.397644 276.911560,168.086044 273.564758,168.774445 
	C273.421509,169.240219 273.278229,169.705994 273.134979,170.171768 
	C275.814850,171.125580 278.438171,172.312469 281.187622,172.979645 
	C285.517242,174.030273 289.930481,174.737671 294.311584,175.573257 
	C294.945007,175.694077 295.678436,175.949112 296.226807,175.753326 
	C300.731995,174.144852 305.204315,172.444351 311.252716,170.187408 
	C308.155365,168.829681 306.088654,167.624435 303.859222,167.005310 
	C298.253967,165.448700 296.648224,163.250900 297.011383,156.922440 
	C297.470947,148.914413 299.715973,146.219803 305.056244,144.795837 
	C308.084198,143.988434 313.611816,146.299194 313.344147,141.107986 
	C319.791626,140.542358 326.028534,140.241547 332.167053,139.299454 
	C333.902252,139.033142 336.573242,136.985565 336.679993,135.591431 
	C336.918579,132.476151 335.558105,129.859772 331.621979,128.944016 
	C326.835388,127.830360 323.064850,128.318771 319.327789,131.818283 
	C318.021057,133.041931 313.987213,133.552429 313.046906,132.587555 
	C308.977386,128.411514 304.044403,127.056992 298.643005,125.808151 
	C290.450500,123.914009 281.345642,123.154816 275.129242,127.658005 
	C267.180450,133.416122 261.703247,131.468475 254.610077,127.675163 
	C252.665619,126.635300 248.025986,128.027130 246.341858,129.872040 
	C244.785080,131.577408 244.648560,135.722733 245.577896,138.144394 
	C246.178345,139.709045 249.769180,140.663422 252.118744,140.896851 
	C255.890945,141.271667 259.746155,140.728577 263.563721,140.777237 
	C264.788147,140.792831 266.062103,141.324081 267.213623,141.841446 
	C270.809204,143.456940 274.221527,145.617905 277.951385,146.768372 
	C285.929962,149.229294 289.347839,159.322235 283.605133,166.709244 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M387.084290,497.081787 
	C383.657593,504.282806 383.657593,504.282806 369.602570,501.532867 
	C369.435394,501.012115 369.084900,500.405457 369.065521,499.788422 
	C368.687683,487.762177 368.035492,475.732178 368.135132,463.708679 
	C368.183899,457.822937 369.888489,451.968872 370.372803,446.061859 
	C370.649689,442.684692 370.060181,439.220764 369.663574,435.818848 
	C369.593140,435.214874 368.631744,434.393005 367.949463,434.231873 
	C360.980408,432.585754 353.953796,431.115997 346.874329,433.427979 
	C346.096893,433.681854 345.658325,435.373016 345.327667,436.476959 
	C345.027344,437.479645 345.088409,438.590637 344.424194,439.753082 
	C342.505890,436.939178 343.542786,431.729706 337.418396,432.999756 
	C336.800873,429.628510 336.649872,426.441589 340.978638,425.161469 
	C342.127655,424.821686 343.141418,423.062683 343.668579,421.737091 
	C347.235931,412.766449 355.168396,412.319305 362.910156,412.077881 
	C373.009308,411.762909 383.128540,411.867157 393.232910,412.082642 
	C396.288513,412.147797 400.183014,411.620453 400.528198,416.736481 
	C384.105408,417.213776 368.141266,417.373596 352.181488,417.178711 
	C344.646057,417.086731 348.398254,422.725800 347.638367,425.778687 
	C346.754791,429.328522 349.971283,429.029083 352.254456,429.046234 
	C357.574799,429.086182 362.914124,429.311707 368.210907,428.950500 
	C372.874390,428.632507 374.212769,430.407562 374.157837,434.923645 
	C373.949585,452.047699 374.073914,469.175751 374.070251,486.302307 
	C374.067627,498.569458 374.734650,499.123444 386.994110,496.994263 
	C386.994110,496.994263 387.054108,497.052765 387.084290,497.081787 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M247.002228,263.002502 
	C245.628082,263.079742 244.253922,263.156982 242.069489,263.170624 
	C236.966919,263.176880 232.777267,263.104675 232.898102,257.066284 
	C232.983994,245.694107 233.069885,234.321915 233.334351,222.196472 
	C234.088867,218.178787 236.459198,217.729813 239.139938,217.983963 
	C246.275497,218.660400 253.389740,219.699722 260.539215,220.052689 
	C267.805176,220.411377 267.678284,220.123962 267.884583,212.687225 
	C268.033936,207.302185 268.619659,201.929245 269.468994,196.649353 
	C283.598602,196.862869 297.269958,196.977921 310.965271,197.055145 
	C310.989258,197.017288 310.907867,197.054749 310.916565,197.463959 
	C311.083130,199.988068 311.240997,202.102936 311.352600,204.634155 
	C311.311523,207.004822 311.316711,208.959167 311.191925,211.280975 
	C311.038727,213.247437 311.108551,214.854416 310.972412,216.443741 
	C310.705750,219.556610 312.159363,220.493332 315.466553,219.937897 
	C326.367706,220.084183 336.815247,219.920227 347.247375,220.247849 
	C360.127441,220.652344 373.102997,220.870499 384.964691,227.059753 
	C385.426300,227.413376 385.887878,227.766998 386.776215,228.491943 
	C390.232086,233.546539 393.261200,238.229813 395.914551,242.894226 
	C394.012543,241.296661 391.883240,239.979584 391.065186,238.093704 
	C387.638397,230.194138 380.234955,227.631027 373.227356,225.470718 
	C367.020905,223.557388 360.187927,223.244034 353.608643,223.064804 
	C340.963287,222.720352 328.301483,223.011459 315.647156,222.931488 
	C313.697662,222.919159 311.497894,222.783524 309.886292,221.870773 
	C308.642883,221.166550 307.488403,219.179398 307.434326,217.720428 
	C307.294281,213.940216 307.927429,210.139038 307.989746,206.341934 
	C308.093414,200.026154 306.671478,198.735825 300.367310,198.978455 
	C291.916870,199.303665 283.468079,199.812439 275.015717,199.879990 
	C271.533661,199.907837 270.918823,201.341980 270.890137,204.382477 
	C270.847168,208.939041 270.668427,213.561417 269.801575,218.010498 
	C269.448425,219.822983 267.109497,222.659531 265.730133,222.627350 
	C257.988159,222.446762 249.864090,225.213181 243.259674,220.604904 
	C241.077606,221.749512 239.312790,222.675262 236.954742,223.912186 
	C236.954742,233.350830 236.876831,243.662872 237.017456,253.971909 
	C237.047241,256.154419 237.875854,258.325989 238.336411,260.502594 
	C240.960968,259.927032 243.590958,259.374542 246.206116,258.759033 
	C246.828522,258.612549 247.401321,258.255371 248.122787,258.229858 
	C248.540237,258.660492 248.831848,258.856415 249.095261,259.381348 
	C248.378784,260.807709 247.690491,261.905090 247.002228,263.002502 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M313.012451,166.618820 
	C311.267395,166.443893 309.537140,165.873825 307.791595,165.355392 
	C300.086060,163.066803 297.889465,159.236618 300.412018,151.606674 
	C300.876404,150.201965 302.723694,148.688721 304.218231,148.286484 
	C311.368622,146.361954 318.287933,143.272171 326.057098,144.200455 
	C328.575562,144.501373 331.420227,143.899719 333.826935,142.966339 
	C341.148438,140.126892 342.025848,132.524048 335.773376,127.718506 
	C331.029266,124.072281 325.465668,123.839272 320.020508,127.586479 
	C317.178345,129.542389 315.138428,129.736664 312.056824,127.749374 
	C299.231476,119.478561 285.485474,119.661430 271.959900,125.390808 
	C266.543152,127.685326 262.494507,128.688370 256.926086,125.543640 
	C249.401810,121.294357 241.596481,125.746925 240.527939,133.842804 
	C239.922256,138.431885 242.286102,142.544205 246.655136,144.050842 
	C248.352295,144.636108 250.345581,145.253860 252.004883,144.906326 
	C259.995636,143.232559 267.294403,145.368515 274.764526,148.638153 
	C272.174652,153.037735 268.920807,149.908157 266.292999,148.895874 
	C262.511414,147.439117 259.325287,144.628418 256.278992,150.140274 
	C255.772797,151.056183 251.562759,151.035751 249.981079,150.020187 
	C246.464310,147.762146 243.605392,144.505402 240.336151,141.829407 
	C236.195969,138.440506 236.387543,134.028671 238.338684,130.079742 
	C240.317291,126.075302 242.009521,121.292328 248.395996,121.520996 
	C251.946228,121.648117 255.246979,120.229973 258.471802,123.380760 
	C259.778748,124.657700 262.960602,124.805237 265.048950,124.354134 
	C273.405548,122.548950 281.579742,119.315948 289.995300,118.568283 
	C295.790497,118.053413 302.319000,119.787796 307.711151,122.272026 
	C314.334564,125.323524 320.475403,123.401794 326.623810,122.448898 
	C331.371063,121.713158 334.533081,123.271805 337.598633,126.104179 
	C340.325104,128.623260 343.285675,130.335999 343.312286,135.408905 
	C343.347748,142.175339 339.082520,144.924255 332.776001,145.900040 
	C330.335663,146.277649 327.741943,145.671875 325.304657,146.059021 
	C322.828339,146.452377 320.474884,147.573563 318.038422,148.274536 
	C314.740997,149.223236 311.461426,150.484100 308.090393,150.860458 
	C304.266754,151.287338 302.279236,153.150314 303.119751,156.644119 
	C303.774536,159.365860 303.619293,163.619888 308.919067,162.804047 
	C310.081879,162.625061 311.642700,165.031601 313.012451,166.618820 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M497.181976,497.511353 
	C495.033081,496.312683 492.884155,495.114014 490.248413,493.547119 
	C488.507263,491.787018 487.252991,490.395111 486.030396,488.965912 
	C486.062073,488.928589 486.125946,488.854370 486.461853,488.860199 
	C487.845306,488.285583 488.892822,487.705139 489.790466,487.207764 
	C487.492615,483.818329 484.279602,481.077606 483.765076,477.899902 
	C482.726379,471.484802 482.944397,464.826965 483.110107,458.281036 
	C483.157043,456.426971 484.409912,454.169525 485.822784,452.875793 
	C488.625183,450.309814 491.923828,448.285767 495.404724,445.980347 
	C500.732941,443.361420 505.084656,446.350464 508.987457,448.226135 
	C512.799744,450.058319 517.412354,453.287598 518.560364,456.894470 
	C520.351501,462.521637 520.167664,469.045776 519.610291,475.078003 
	C519.033081,481.325562 515.594360,486.599518 509.083740,488.253387 
	C504.873108,489.322998 500.331879,489.081665 495.941254,489.456970 
	C494.378296,489.590576 492.822693,489.810364 491.263733,489.990814 
	C508.330200,497.143768 508.581940,497.466858 519.022217,489.332062 
	C522.535034,486.594940 525.535217,482.088837 526.798584,477.809326 
	C529.355164,469.149292 529.766113,460.826904 523.394165,452.420868 
	C515.471863,441.969727 509.118439,438.446198 496.146912,441.830322 
	C494.660553,442.218109 493.336090,443.226562 491.569397,443.964203 
	C490.243591,444.758667 489.356567,445.655060 488.309387,446.285339 
	C486.799469,447.194153 484.842499,448.856506 483.685974,448.452393 
	C482.426086,448.012177 481.712646,445.638092 481.057648,443.989197 
	C480.717621,443.133270 481.017944,442.023010 481.327728,440.996094 
	C481.826355,440.951294 482.026306,440.938049 482.428040,441.230530 
	C482.876251,443.127991 483.122589,444.719696 483.442139,446.784332 
	C486.242004,444.577576 488.556152,442.209686 491.338043,440.708710 
	C494.327606,439.095703 497.756317,438.296570 501.393372,437.182373 
	C502.862823,437.180695 503.932251,437.138916 505.341492,437.262299 
	C519.433289,439.700073 527.976746,447.862488 530.026184,461.401703 
	C531.030945,468.039856 529.284424,475.094421 528.783142,481.960541 
	C528.783142,481.960541 528.640259,482.240387 528.459656,482.564148 
	C528.136719,483.222778 527.994385,483.557587 527.852051,483.892395 
	C527.852051,483.892395 527.982178,483.983612 527.697754,484.036041 
	C527.279419,484.393860 527.145630,484.699219 527.011780,485.004608 
	C526.324158,486.100311 525.636475,487.196045 524.558167,488.672943 
	C523.083618,490.311737 521.999756,491.569336 520.610107,492.925659 
	C519.749146,493.632172 519.193970,494.239960 518.638733,494.847717 
	C518.268188,494.895813 517.897583,494.943909 517.027588,495.117493 
	C516.208923,495.388489 516.016174,495.633575 515.949951,495.978210 
	C515.668762,496.154907 515.387573,496.331573 514.966675,496.718750 
	C514.296814,497.008484 513.766663,497.087708 512.580994,497.421753 
	C507.010986,497.621521 502.096466,497.566437 497.181976,497.511353 
M490.413879,451.811981 
	C484.923187,457.122223 482.352600,469.538544 485.307983,476.474365 
	C489.002502,485.144958 499.707306,489.415741 507.642181,485.891754 
	C517.671631,481.437439 520.644287,467.511078 515.852844,458.390045 
	C512.059570,451.169128 501.934967,443.919525 490.413879,451.811981 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M146.984131,496.959473 
	C145.613602,497.017761 144.243088,497.076050 142.006088,497.107300 
	C131.230972,497.080261 121.322311,497.080261 110.981598,497.080261 
	C110.981598,470.176575 110.981598,444.085968 110.981598,417.995361 
	C110.981598,417.995361 111.003349,417.998016 111.465660,417.939270 
	C122.519974,417.881836 133.139038,417.410217 143.696518,418.014618 
	C154.713989,418.645355 164.105469,423.061646 169.755417,432.969849 
	C168.107040,432.402496 166.665405,432.040436 165.626068,431.187897 
	C163.353897,429.324219 161.606552,426.192444 159.073318,425.395599 
	C152.094925,423.200684 145.403931,419.763336 137.514572,420.824768 
	C131.630173,421.616486 125.554192,420.975830 119.563553,420.988434 
	C113.471161,421.001282 113.009857,421.407074 113.002907,427.485809 
	C112.978958,448.453094 112.992638,469.420410 113.020943,490.387695 
	C113.022865,491.814575 113.263908,493.241150 113.422920,494.988434 
	C123.460533,494.988434 133.040100,495.072540 142.615051,494.899780 
	C144.088501,494.873230 145.540619,493.665253 147.404236,493.003448 
	C156.723083,492.417877 161.884842,486.249359 167.356293,480.009460 
	C168.121155,479.301483 168.567154,478.651306 169.019226,477.665894 
	C169.351196,476.559723 169.677109,475.788849 170.377487,474.947327 
	C174.719650,469.320923 172.702271,462.997253 173.045776,456.550049 
	C173.032333,454.415253 173.021744,452.707245 173.050980,450.637268 
	C174.252136,445.631439 173.154953,441.974945 168.338943,440.220581 
	C169.444275,438.195068 170.351791,436.532043 171.547073,435.059631 
	C173.437576,438.678101 175.040314,442.105957 176.597031,445.788879 
	C176.664307,446.366516 176.777618,446.689117 176.853882,447.439423 
	C177.027969,449.563538 177.239090,451.259949 177.361389,453.402710 
	C177.289261,456.577271 177.305954,459.305481 177.239807,462.395264 
	C177.159195,463.497162 177.161407,464.237488 177.030792,465.339661 
	C174.647858,476.035675 170.387375,485.229736 160.918594,490.815369 
	C156.576584,493.376709 151.647156,494.942291 146.984131,496.959473 
z"/>
<path fill="#6EAFD4" opacity="1.000000" stroke="none" 
	d="
M387.029297,496.527161 
	C374.734650,499.123444 374.067627,498.569458 374.070251,486.302307 
	C374.073914,469.175751 373.949585,452.047699 374.157837,434.923645 
	C374.212769,430.407562 372.874390,428.632507 368.210907,428.950500 
	C362.914124,429.311707 357.574799,429.086182 352.254456,429.046234 
	C349.971283,429.029083 346.754791,429.328522 347.638367,425.778687 
	C348.398254,422.725800 344.646057,417.086731 352.181488,417.178711 
	C368.141266,417.373596 384.105408,417.213776 400.531982,417.130005 
	C404.603363,417.105286 408.210480,417.149933 412.249481,417.186157 
	C412.968353,420.404877 413.518555,423.645477 413.354034,426.849365 
	C413.313782,427.633575 410.956329,428.867249 409.626556,428.918549 
	C403.806824,429.143066 397.965485,429.191254 392.147552,428.941315 
	C388.219513,428.772583 386.995239,430.163910 387.025604,434.111908 
	C387.184326,454.760162 387.078400,475.410461 387.029297,496.527161 
M376.417664,489.477539 
	C376.211151,495.364532 376.523621,495.511536 385.002441,493.131958 
	C385.002441,489.859009 385.002441,486.428558 385.015167,482.061127 
	C385.010101,466.041168 385.005066,450.021179 385.003326,433.264160 
	C384.260956,428.767578 385.639648,427.205353 391.027405,427.040100 
	C396.337982,426.877258 401.672791,427.224213 406.962738,426.855804 
	C408.352936,426.759003 409.616241,424.840759 410.937805,423.758942 
	C409.700806,422.502197 408.539398,420.251007 407.214569,420.150360 
	C398.726929,419.505463 390.203400,419.073822 381.691772,419.076080 
	C372.834564,419.078430 363.979279,419.735962 355.119263,419.919586 
	C352.473511,419.974426 349.909302,420.521606 350.374908,423.370422 
	C350.610046,424.809418 353.425598,426.664001 355.225800,426.847717 
	C359.993408,427.334290 364.906830,426.545105 369.637268,427.185913 
	C372.540833,427.579224 375.214447,429.669739 377.381073,431.472687 
	C376.921509,433.700714 376.043793,435.933502 376.068970,438.156036 
	C376.260925,455.098175 376.629089,472.038330 376.417664,489.477539 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M176.890915,447.011719 
	C176.777618,446.689117 176.664307,446.366516 176.710297,445.302887 
	C176.902191,441.710358 176.934799,438.858826 176.967422,436.007324 
	C181.362915,434.849426 185.164520,434.608307 185.367935,440.874359 
	C185.381088,441.279602 187.226471,441.625305 188.628571,442.379364 
	C189.081100,443.260681 189.124603,443.761383 189.168106,444.262054 
	C189.168106,444.262054 189.030014,444.657257 188.583801,444.874817 
	C186.965820,449.517212 185.723114,453.967407 192.346237,456.153107 
	C192.945587,454.631073 193.464462,453.313416 193.983353,451.995728 
	C193.983353,451.995728 194.272003,451.790619 194.891876,451.853851 
	C196.972733,451.777069 198.583084,451.987122 199.869675,451.438263 
	C206.477478,448.619293 213.208984,448.315643 220.112610,449.953339 
	C220.112610,449.953339 220.326981,450.146759 220.236404,450.735199 
	C220.263748,452.784180 219.834763,454.695862 220.599472,455.622833 
	C223.159012,458.725464 221.238724,460.304352 219.000885,461.981262 
	C218.559570,461.959991 218.118240,461.938721 217.279297,461.474426 
	C215.579727,461.049530 214.277771,461.067657 212.975815,461.085815 
	C210.951630,461.135986 208.927460,461.186127 206.231766,460.891785 
	C204.283447,460.375305 202.466202,459.581970 201.824509,460.140106 
	C199.215897,462.409149 193.693787,459.571136 193.114212,465.139893 
	C193.114212,465.139893 192.985825,465.080505 192.629730,465.051147 
	C189.180435,464.659882 187.362534,465.589264 188.118835,469.125153 
	C188.118835,469.125153 188.065216,468.984375 187.734680,469.025848 
	C185.941666,471.045563 184.479202,473.023773 183.016754,475.002014 
	C181.571274,474.332825 180.125778,473.663635 178.318176,472.647522 
	C177.960144,471.860840 177.964203,471.421082 178.293457,470.848999 
	C179.635101,469.357574 181.475052,468.024780 181.519470,466.634613 
	C181.676285,461.725067 181.232376,456.795166 180.987549,451.874390 
	C180.856277,449.236176 180.420822,446.808075 176.890915,447.011719 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M390.927826,306.010590 
	C392.673859,310.708618 394.907562,315.292908 396.037048,320.134766 
	C397.321899,325.642914 399.091766,330.182007 405.257904,331.538269 
	C405.598511,331.613129 405.726898,332.652863 406.009583,334.001709 
	C405.651245,337.325684 406.152313,341.186035 404.667023,342.235718 
	C397.818268,347.075714 390.693970,352.252380 381.457275,349.922760 
	C374.985596,348.290497 365.545197,344.119415 365.019806,337.036560 
	C365.780212,337.027283 366.540619,337.018005 367.727570,337.375061 
	C368.951996,339.159729 369.469086,340.870697 370.593018,341.949249 
	C378.254150,349.301056 391.378998,349.881470 399.923492,343.341095 
	C402.435059,341.418640 404.665649,338.967041 402.403839,335.798187 
	C400.065369,332.521912 397.268250,334.070679 394.654114,336.013092 
	C389.127533,340.119598 382.449799,340.376862 377.271790,336.123413 
	C374.497223,333.844299 372.046051,333.736786 369.098541,335.019897 
	C368.009369,333.869141 366.920166,332.718384 365.709961,331.439789 
	C368.020325,330.495483 369.772888,329.581604 371.635529,329.064331 
	C374.390839,328.299286 374.758453,326.496002 375.165100,323.918762 
	C375.815491,319.796692 377.504669,315.849213 378.520142,311.769501 
	C379.003601,309.827087 378.946838,307.750214 379.485443,305.359039 
	C381.592499,305.105835 383.348938,305.227844 385.060883,305.690063 
	C382.940704,310.363403 380.192627,314.524109 379.021973,319.089325 
	C378.220306,322.215576 378.769073,326.340332 380.254059,329.226379 
	C381.902100,332.429230 385.740112,332.558990 389.167328,331.127441 
	C393.056641,329.502838 395.009552,325.344391 393.346558,320.727905 
	C391.443146,315.444153 388.899719,310.390930 387.001892,305.184631 
	C388.555511,305.424652 389.741669,305.717621 390.927826,306.010590 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M318.339539,189.067535 
	C318.153778,189.459366 317.968018,189.851196 317.338318,190.533325 
	C315.599365,191.205063 314.304352,191.586533 312.569305,191.891815 
	C309.753418,191.865356 307.377563,191.915085 304.537659,191.890350 
	C293.715607,191.865524 283.357666,191.915146 272.563538,191.893539 
	C270.051880,191.792587 267.976379,191.762863 265.718628,191.541748 
	C264.841339,190.842102 264.146301,190.333847 263.371826,189.442352 
	C263.574371,187.078903 263.856354,185.098740 264.138336,183.118561 
	C264.138336,183.118561 264.056458,182.988586 264.473297,182.909058 
	C265.669067,182.582993 266.447052,182.124512 267.227020,182.121170 
	C282.369995,182.056137 297.513367,181.999512 312.656281,182.048660 
	C317.227203,182.063492 318.550995,185.020309 318.339539,189.067535 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M300.157349,462.776306 
	C300.590027,462.682312 301.022705,462.588257 302.188477,462.378723 
	C310.933624,462.495819 318.945709,462.728363 327.022400,463.024933 
	C327.087067,463.088959 327.215698,463.217651 327.048950,463.571777 
	C323.757874,464.526093 320.633575,465.126312 317.509247,465.726532 
	C320.492645,467.016449 323.670715,466.961456 326.159271,468.244171 
	C327.918884,469.151123 329.448639,471.746216 329.810272,473.810333 
	C330.268005,476.422943 330.990112,480.000671 326.672119,480.374451 
	C326.745911,478.133087 327.210266,476.198425 326.719849,474.547333 
	C326.238495,472.926605 325.046814,470.656403 323.718323,470.287750 
	C315.203857,467.925079 306.787872,467.330414 299.380249,474.057495 
	C299.247437,472.882935 299.544891,471.826874 299.549561,470.769531 
	C299.552765,470.039459 299.362457,468.986877 298.872711,468.664276 
	C298.354065,468.322601 297.285187,468.463196 296.618347,468.758484 
	C293.121002,470.306732 289.035461,479.241577 290.099121,482.820465 
	C292.519287,490.963684 303.757477,497.643768 312.218048,495.968140 
	C315.190582,495.379425 319.922546,491.417542 320.060608,489.785950 
	C313.615540,490.848145 307.065186,493.254669 301.520386,487.931519 
	C302.499939,487.832794 303.057495,487.739838 303.976746,487.755615 
	C312.427979,490.414368 319.483887,488.489716 326.001831,483.109802 
	C326.566650,485.308380 326.829773,487.327179 326.892212,489.603394 
	C324.333252,492.177368 321.975037,494.493896 319.196289,496.799805 
	C313.837006,497.183380 308.884644,498.022430 303.962616,497.871521 
	C295.811676,497.621613 290.281494,492.826630 287.801819,484.766693 
	C285.658295,477.799377 287.872864,471.587006 294.412231,466.576904 
	C296.230560,465.183838 298.237122,464.036407 300.157349,462.776306 
M310.602631,466.665466 
	C311.287628,466.120667 311.972626,465.575836 312.657623,465.031006 
	C312.525269,464.638306 312.392883,464.245575 312.260498,463.852844 
	C308.990814,464.419312 305.721161,464.985748 302.451477,465.552216 
	C302.443604,466.005127 302.435699,466.458008 302.427826,466.910919 
	C304.895050,466.910919 307.362244,466.910919 310.602631,466.665466 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M300.026642,462.397827 
	C298.237122,464.036407 296.230560,465.183838 294.412231,466.576904 
	C287.872864,471.587006 285.658295,477.799377 287.801819,484.766693 
	C290.281494,492.826630 295.811676,497.621613 303.962616,497.871521 
	C308.884644,498.022430 313.837006,497.183380 319.499176,496.846161 
	C320.425812,496.921204 320.628998,496.939209 320.832214,496.957245 
	C320.273956,497.946686 319.866089,499.663208 319.134521,499.814484 
	C310.661499,501.566711 302.300537,503.060669 294.205719,497.719666 
	C291.095734,495.667694 286.925690,495.222260 282.808868,493.609741 
	C281.837280,490.490479 281.295502,487.806274 280.753754,485.122101 
	C280.443115,485.602203 280.132477,486.082336 279.821838,486.562439 
	C275.367554,485.820709 270.913239,485.078949 266.424194,484.046753 
	C266.208038,483.184021 266.026581,482.611664 265.907318,481.765411 
	C265.911835,481.313477 265.854218,481.135498 265.845520,480.523682 
	C265.855103,478.053467 265.815765,476.017059 265.872314,473.524628 
	C265.902130,468.360260 265.836090,463.651917 265.824310,458.619324 
	C265.851959,457.858673 265.825378,457.422241 265.891693,456.558533 
	C266.026215,453.589661 266.067810,451.048065 266.404907,448.374329 
	C267.109741,448.106140 267.519073,447.970093 268.191589,447.933167 
	C268.639862,448.003479 268.824921,447.974640 269.357178,447.989319 
	C270.155548,447.928558 270.606689,447.824280 271.368774,447.804810 
	C272.100372,447.830658 272.521088,447.771667 273.305237,447.835846 
	C274.426544,447.907379 275.184418,447.855713 276.214783,447.979156 
	C276.664948,448.277100 276.842590,448.399872 277.020203,448.522614 
	C275.529114,449.310394 274.038055,450.098206 272.883881,450.707977 
	C266.975830,459.143677 269.287262,468.595154 269.045807,477.681000 
	C268.919556,482.431244 271.093475,483.680267 275.682800,482.361908 
	C276.881256,482.017670 278.276978,482.266113 279.570892,482.375336 
	C280.811005,482.479950 282.036530,482.757294 282.183350,482.781311 
	C284.338287,477.347687 285.407990,472.005310 288.346863,468.052673 
	C290.828430,464.715088 294.003815,460.015900 300.026642,462.397827 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M247.152374,263.315125 
	C247.690491,261.905090 248.378784,260.807709 249.403671,259.159790 
	C257.886597,255.301178 266.212860,257.572632 274.835327,256.940948 
	C274.056641,264.903290 277.886017,269.342133 283.721252,272.460449 
	C300.953644,281.669312 319.810669,273.486359 325.201477,254.661972 
	C325.865112,252.344559 327.751740,250.377380 329.497131,248.233154 
	C335.960114,248.060364 341.997559,247.902298 348.035004,247.744247 
	C346.191986,248.153748 344.353180,248.894852 342.505249,248.918259 
	C331.569702,249.056824 329.194519,250.364868 326.185425,260.404236 
	C324.814392,264.978577 322.826782,268.263031 318.487762,270.481720 
	C316.132904,271.685852 314.709900,274.755371 312.342407,275.883545 
	C305.970917,278.919739 299.335175,280.833954 292.121155,278.184448 
	C290.759003,277.684174 288.756989,278.926117 286.686279,279.457550 
	C282.891907,276.792480 278.548737,274.085114 274.676849,270.819061 
	C273.471588,269.802368 273.185059,267.286713 273.115326,265.433319 
	C273.019440,262.883148 272.076660,262.185120 269.570740,261.874268 
	C262.688568,261.020599 255.863388,259.590057 249.807556,264.655487 
	C249.484863,264.925385 248.160568,263.997864 247.152374,263.315125 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M281.898529,494.838654 
	C279.946808,501.210297 278.802765,501.995422 272.882050,501.128326 
	C272.071106,501.009521 271.202209,500.941406 270.409210,501.098175 
	C261.094696,502.939362 253.362839,498.619324 249.890915,489.492981 
	C249.629120,488.804871 250.007507,487.891205 250.008804,487.082306 
	C250.026321,476.121490 250.048355,465.160583 250.012894,454.199921 
	C250.008514,452.847687 249.679245,451.496490 249.463730,449.866486 
	C247.429443,451.042358 246.037170,451.847107 244.644882,452.651886 
	C244.102203,450.862366 243.244003,449.098480 243.095795,447.276855 
	C242.905746,444.940887 242.712021,442.319366 243.569656,440.257568 
	C244.601990,437.775757 246.737213,435.752716 248.970764,434.125336 
	C250.069321,429.796509 251.167877,425.467712 252.727356,421.532379 
	C253.025146,427.519806 252.862030,433.113770 252.329865,438.724365 
	C250.974503,438.812927 249.988190,438.884827 248.582047,438.882141 
	C244.870819,441.338043 244.809586,445.458008 248.437286,447.936340 
	C252.871490,447.562286 253.845215,449.552032 253.779144,453.296570 
	C253.592148,463.894592 253.721863,474.498932 253.788803,485.100403 
	C253.833786,492.226562 257.022736,496.944733 264.038177,497.336365 
	C269.926788,497.665070 275.940308,495.756622 281.898529,494.838654 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M318.685425,188.962570 
	C318.550995,185.020309 317.227203,182.063492 312.656281,182.048660 
	C297.513367,181.999512 282.369995,182.056137 267.227020,182.121170 
	C266.447052,182.124512 265.669067,182.582993 264.506226,182.976227 
	C263.482941,176.934036 269.166138,180.207230 271.865570,178.038803 
	C270.731110,176.968704 269.886047,175.613632 268.692780,175.144791 
	C264.101379,173.340790 264.694977,170.656921 267.592102,168.101395 
	C270.349487,165.669113 273.450989,163.524429 276.674957,161.750977 
	C280.271729,159.772476 280.647766,153.997955 277.016205,149.634979 
	C279.581604,149.734497 282.666809,149.127335 282.872559,153.499557 
	C283.299652,162.576431 282.937561,163.077896 277.790710,164.991745 
	C274.641876,166.162628 271.966522,168.606934 269.078522,170.479340 
	C271.999176,172.328217 274.701782,175.126190 277.879486,175.856384 
	C289.611877,178.552277 301.340698,178.204834 313.056183,173.600952 
	C315.461151,177.923218 310.550720,176.189774 309.474426,177.864731 
	C311.785004,181.626144 317.060913,175.206253 318.507538,180.479446 
	C319.232269,183.121262 318.890656,186.055588 318.685425,188.962570 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M298.989868,438.995117 
	C301.196930,437.496490 303.242065,435.140869 305.646454,434.686584 
	C309.987427,433.866394 314.553284,434.318329 319.006500,433.987061 
	C323.606415,433.644958 326.624939,435.788055 330.378326,438.418030 
	C341.349304,446.105225 342.996124,456.763062 343.086792,468.735107 
	C343.145203,476.443115 344.635590,484.131470 344.904877,491.848846 
	C345.287048,502.802185 344.679993,503.202271 334.011322,502.963013 
	C332.879822,502.937622 331.751801,502.755463 330.582520,502.642181 
	C330.136780,500.851013 329.742706,499.267548 329.484924,497.110870 
	C329.850311,496.148041 330.079437,495.758423 330.568176,495.529907 
	C331.217712,495.791260 331.607605,495.891449 332.196472,496.265472 
	C333.492706,496.742157 334.590027,496.945007 335.872467,497.317627 
	C336.516785,497.392212 336.976013,497.297058 337.698120,497.294403 
	C338.326477,497.343628 338.691956,497.300385 339.473785,497.278076 
	C340.852112,496.134186 342.790375,494.781860 342.608826,493.836700 
	C341.773041,489.485352 340.346008,485.247589 339.161926,480.573090 
	C339.157806,479.119568 339.122803,478.062073 339.185913,476.542969 
	C339.297791,472.922089 339.550659,469.741394 339.270813,466.608307 
	C338.820648,461.567383 338.018707,456.557892 337.362030,451.369202 
	C337.358673,451.203308 337.177368,450.925323 337.181274,450.559143 
	C335.047943,444.538269 331.097443,440.953644 324.918549,439.476685 
	C324.131104,439.176819 323.574280,439.049866 322.808594,438.799316 
	C322.599762,438.675751 322.115051,438.672546 321.728302,438.512573 
	C316.863556,438.394012 312.385559,438.435394 307.593994,438.390472 
	C306.632812,438.242310 305.985168,438.180420 305.087677,438.137146 
	C304.497955,438.244598 304.235229,438.438110 303.830383,438.838287 
	C302.844360,438.973297 302.077545,439.006317 300.923279,439.024323 
	C300.020538,439.004608 299.505188,438.999847 298.989868,438.995117 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M364.804810,336.765198 
	C365.545197,344.119415 374.985596,348.290497 381.457275,349.922760 
	C390.693970,352.252380 397.818268,347.075714 404.667023,342.235718 
	C406.152313,341.186035 405.651245,337.325684 406.022644,334.383972 
	C409.388611,335.351227 412.797058,336.694366 416.333466,338.087982 
	C414.737640,339.633667 412.873871,341.438904 410.641296,343.670654 
	C410.112793,344.136200 409.944336,344.154388 409.794586,344.217133 
	C403.434052,346.883301 398.907104,352.921783 391.698669,354.086823 
	C391.368469,354.140198 391.203003,355.212921 390.601501,355.906006 
	C389.501495,356.016296 388.760773,356.031494 387.779846,355.750336 
	C382.107849,353.536804 375.947479,354.003998 371.112610,349.984558 
	C368.969391,348.202850 367.415558,344.505219 363.188354,346.360352 
	C362.610413,346.289978 362.285309,346.203156 361.946350,345.758514 
	C361.052612,344.746185 360.172791,344.091705 359.292938,343.437225 
	C358.540863,344.651581 357.788788,345.865936 356.924316,347.174927 
	C356.811951,347.269562 356.548859,347.400391 356.217560,347.366577 
	C355.260468,347.560028 354.634674,347.787231 354.008881,348.014465 
	C352.601410,342.501953 357.807312,336.833710 364.804810,336.765198 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M529.193115,481.937317 
	C529.284424,475.094421 531.030945,468.039856 530.026184,461.401703 
	C527.976746,447.862488 519.433289,439.700073 505.389160,436.909668 
	C505.576050,436.054810 506.100769,435.376404 506.527100,435.433472 
	C510.865906,436.014282 515.190857,436.701904 519.512390,437.404053 
	C519.905640,437.467957 520.337158,437.766296 520.601379,438.081238 
	C523.082947,441.039001 525.531921,444.024048 527.990356,447.001221 
	C529.935852,448.131317 531.881348,449.261444 533.826904,450.391541 
	C534.294189,450.062103 534.761536,449.732635 535.228882,449.403198 
	C535.505249,453.215515 535.508484,457.073395 536.134338,460.827454 
	C536.767883,464.627472 538.640503,468.287781 538.865723,472.074982 
	C539.315918,479.647217 539.003296,479.661407 531.496033,481.319427 
	C530.852722,481.461487 530.233521,481.713226 529.193115,481.937317 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M110.617699,418.058289 
	C110.981598,444.085968 110.981598,470.176575 110.981598,497.080261 
	C121.322311,497.080261 131.230972,497.080261 141.602585,497.186462 
	C140.863953,498.174103 139.689789,499.770660 138.456207,499.817993 
	C131.737167,500.075806 125.003082,500.001953 118.274963,499.946777 
	C109.896744,499.878082 108.046181,498.015289 108.045433,489.885925 
	C108.043594,469.764740 108.116035,449.643005 107.977440,429.522766 
	C107.949646,425.486694 107.701080,421.569183 110.617699,418.058289 
z"/>
<path fill="#58AEE5" opacity="1.000000" stroke="none" 
	d="
M369.040405,335.310028 
	C372.046051,333.736786 374.497223,333.844299 377.271790,336.123413 
	C382.449799,340.376862 389.127533,340.119598 394.654114,336.013092 
	C397.268250,334.070679 400.065369,332.521912 402.403839,335.798187 
	C404.665649,338.967041 402.435059,341.418640 399.923492,343.341095 
	C391.378998,349.881470 378.254150,349.301056 370.593018,341.949249 
	C369.469086,340.870697 368.951996,339.159729 368.107422,337.392578 
	C368.367889,336.562561 368.675110,336.081360 369.040405,335.310028 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M368.147125,299.736969 
	C368.147125,299.736969 368.072357,299.359619 368.050415,298.751465 
	C368.136261,296.558319 368.244019,294.973328 368.386169,292.882660 
	C378.129425,292.882660 387.517365,293.144684 396.880371,292.775269 
	C401.767639,292.582397 403.562805,294.231934 402.451599,299.122192 
	C400.754578,300.108643 399.340973,301.612366 397.952881,301.589142 
	C387.996460,301.422699 377.853912,303.847046 368.147125,299.736969 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M189.518982,444.185486 
	C189.124603,443.761383 189.081100,443.260681 189.032471,442.383057 
	C189.118454,441.685150 189.300751,441.429108 190.161346,441.097595 
	C197.022217,438.530029 203.054352,435.229736 210.166382,435.871429 
	C210.741501,435.923340 211.433289,434.682037 212.070862,434.041656 
	C221.876266,432.179932 229.095963,437.487000 234.853851,443.919159 
	C237.949600,447.377441 239.206284,453.171844 239.752045,458.083374 
	C240.993713,469.257233 241.342758,480.533936 241.896317,491.776642 
	C241.978226,493.440155 241.198776,495.146057 240.429688,496.916199 
	C239.126373,493.316467 242.045380,488.961517 237.706085,485.512268 
	C237.329666,485.212952 237.164993,484.942505 237.164993,484.942505 
	C237.080811,476.810486 237.017029,468.678192 236.907913,460.546509 
	C236.722092,446.698761 227.938797,438.207733 214.020233,437.778412 
	C205.248047,437.507874 197.297501,439.623779 189.518982,444.185486 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M272.999695,191.964783 
	C283.357666,191.915146 293.715607,191.865524 304.522949,192.309387 
	C303.605377,193.536560 302.251221,194.876495 300.869385,194.905655 
	C291.814484,195.096771 282.752472,194.931625 273.695801,195.074387 
	C272.126740,195.099136 270.572083,196.035599 269.010773,196.550934 
	C268.619659,201.929245 268.033936,207.302185 267.884583,212.687225 
	C267.678284,220.123962 267.805176,220.411377 260.539215,220.052689 
	C253.389740,219.699722 246.275497,218.660400 239.139938,217.983963 
	C236.459198,217.729813 234.088867,218.178787 233.288544,221.730713 
	C232.599899,221.258850 231.590637,220.003387 231.758301,219.819214 
	C233.013138,218.440582 234.393372,216.399521 235.935898,216.210480 
	C239.955078,215.717896 244.077576,216.045883 248.158142,216.100647 
	C248.799179,216.109238 249.433334,216.413864 250.075882,216.558334 
	C262.982941,219.459869 265.115875,217.925262 264.964081,205.230103 
	C264.904846,200.276489 266.564789,194.868530 262.456299,190.315979 
	C262.984772,189.891815 263.217987,189.858719 263.451233,189.825607 
	C264.146301,190.333847 264.841339,190.842102 265.936340,191.860596 
	C268.545593,192.041122 271.035004,196.308365 272.999695,191.964783 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M528.284790,446.718170 
	C525.531921,444.024048 523.082947,441.039001 520.601379,438.081238 
	C520.337158,437.766296 519.905640,437.467957 519.512390,437.404053 
	C515.190857,436.701904 510.865906,436.014282 506.527100,435.433472 
	C506.100769,435.376404 505.576050,436.054810 505.049316,436.744507 
	C503.932251,437.138916 502.862823,437.180695 501.394775,436.771454 
	C500.993835,433.577179 500.306885,431.817108 497.276611,433.966522 
	C494.200226,436.148651 491.316864,438.641235 488.072632,440.520935 
	C487.283478,440.978149 485.032806,439.908691 484.137787,438.921417 
	C483.142883,437.823975 482.929596,436.017975 482.376007,434.520447 
	C480.402527,434.987427 479.073700,434.362091 477.689667,433.903107 
	C476.495636,433.507172 475.238831,433.300629 474.009766,433.010376 
	C474.009766,433.010376 474.002655,433.002777 474.000244,433.000183 
	C476.955841,429.102478 480.205109,431.103394 483.506989,432.432159 
	C484.877808,432.983795 486.928558,433.890808 487.799957,433.316315 
	C495.063873,428.527649 503.021912,432.080841 510.562256,431.102844 
	C510.862274,431.063965 511.368286,431.177094 511.486877,431.385284 
	C514.276855,436.285309 518.580627,435.802551 523.363892,435.423431 
	C527.250427,435.115356 529.900757,437.397400 529.021057,442.018097 
	C528.745422,443.466003 528.719482,444.961426 528.284790,446.718170 
M489.824921,435.244751 
	C489.880371,435.411682 489.935822,435.578613 489.991241,435.745544 
	C490.045288,435.577606 490.099335,435.409668 489.824921,435.244751 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M282.023376,494.613892 
	C275.940308,495.756622 269.926788,497.665070 264.038177,497.336365 
	C257.022736,496.944733 253.833786,492.226562 253.788803,485.100403 
	C253.721863,474.498932 253.592148,463.894592 253.779144,453.296570 
	C253.845215,449.552032 252.871490,447.562286 248.434937,447.572388 
	C248.035599,446.396637 248.048218,445.664246 248.448639,444.958160 
	C251.183273,446.237579 255.402390,447.286926 255.564590,448.777679 
	C256.434692,456.774994 256.126984,464.891205 256.558502,472.948547 
	C256.877991,478.914124 256.935822,485.090271 258.666687,490.691620 
	C259.408997,493.093719 264.127380,495.723206 266.990234,495.668915 
	C271.170319,495.589600 275.318542,493.217926 279.437225,491.705902 
	C279.758575,491.587952 279.741730,490.548798 280.076538,489.091003 
	C278.118134,489.091003 276.566895,489.107361 275.016144,489.086517 
	C273.383026,489.064606 271.748871,488.941132 270.117889,488.979095 
	C266.789215,489.056641 265.494995,487.605957 266.458954,484.337189 
	C270.913239,485.078949 275.367554,485.820709 279.821838,486.562439 
	C280.132477,486.082336 280.443115,485.602203 280.753754,485.122101 
	C281.295502,487.806274 281.837280,490.490479 282.448120,493.602722 
	C282.394165,494.150238 282.271179,494.269684 282.023376,494.613892 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M402.746826,298.932648 
	C403.562805,294.231934 401.767639,292.582397 396.880371,292.775269 
	C387.517365,293.144684 378.129425,292.882660 368.386169,292.882660 
	C368.244019,294.973328 368.136261,296.558319 367.965393,298.578979 
	C367.018860,297.593353 365.391266,296.150085 365.432465,294.756195 
	C365.489380,292.830902 366.804321,290.942841 368.284393,289.081055 
	C379.869720,289.123322 390.751038,289.123322 401.994629,289.123322 
	C401.994629,281.228790 401.994629,274.113861 402.362000,266.998230 
	C403.461670,266.993744 404.194000,266.990051 404.926270,266.986328 
	C404.757874,274.700958 404.541870,282.415161 404.470032,290.130707 
	C404.458649,291.353088 405.298279,292.567749 405.383209,293.810699 
	C405.485748,295.311829 405.203217,296.839233 404.655762,298.675049 
	C403.731720,298.974060 403.239258,298.953369 402.746826,298.932648 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M187.392914,490.433777 
	C200.348358,501.197723 210.736359,500.952515 225.905945,489.105804 
	C227.093338,496.876495 232.108383,498.603119 239.236847,497.378906 
	C239.016647,498.517212 238.346054,500.702972 237.772797,500.677734 
	C233.384155,500.484497 228.659332,502.816132 224.794785,498.146454 
	C222.563919,495.450775 218.804535,496.478210 217.047592,499.155792 
	C214.032623,503.750519 209.970016,504.238617 205.554733,502.871521 
	C200.509506,501.309357 195.686996,499.027954 190.355225,496.697083 
	C189.302444,495.882782 188.662155,495.430542 188.021851,494.978302 
	C188.021851,494.978302 188.000000,494.998779 187.966232,494.604523 
	C187.752609,492.951447 187.572769,491.692596 187.392914,490.433777 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M176.827759,435.695801 
	C176.934799,438.858826 176.902191,441.710358 176.756317,445.047852 
	C175.040314,442.105957 173.437576,438.678101 171.495834,434.774353 
	C170.819427,433.849854 170.482025,433.401276 170.144623,432.952698 
	C164.105469,423.061646 154.713989,418.645355 143.696518,418.014618 
	C133.139038,417.410217 122.519974,417.881836 111.460388,417.929077 
	C112.287163,417.327850 113.589714,416.099182 114.874626,416.117371 
	C128.578354,416.311279 142.320053,416.181458 155.964661,417.248596 
	C163.364975,417.827423 168.005203,424.040466 172.556824,429.446686 
	C174.103119,431.283417 175.320450,433.397095 176.827759,435.695801 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M384.974915,226.684540 
	C373.102997,220.870499 360.127441,220.652344 347.247375,220.247849 
	C336.815247,219.920227 326.367706,220.084183 315.464508,219.592911 
	C314.994659,218.466217 314.987305,217.776733 314.979980,217.087250 
	C326.283234,217.070816 337.613892,216.560715 348.881592,217.185608 
	C358.880341,217.740128 368.859741,219.270309 378.731598,221.023529 
	C381.055756,221.436264 382.913086,224.477371 384.974915,226.684540 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M401.994629,266.998962 
	C401.994629,274.113861 401.994629,281.228790 401.994629,289.123322 
	C390.751038,289.123322 379.869720,289.123322 368.625946,289.037720 
	C368.235229,288.235229 368.206940,287.518372 368.523987,286.333252 
	C368.999481,285.314972 369.129639,284.764923 369.259796,284.214844 
	C369.259796,284.214844 369.183533,284.184387 369.456604,283.949646 
	C369.882202,282.117004 370.034698,280.519104 370.253204,278.515686 
	C370.327454,275.742432 370.335663,273.374725 370.449524,270.658936 
	C370.079620,268.434143 369.604004,266.557465 369.143646,264.504272 
	C369.158875,264.327789 369.008728,264.006897 369.025665,263.679810 
	C368.739044,262.794708 368.435486,262.236725 368.083435,261.336304 
	C366.216949,258.081512 364.398956,255.169174 362.960083,252.192322 
	C364.913483,253.460709 366.964172,254.504532 367.978882,256.176941 
	C372.210236,263.150665 374.914398,270.626465 373.734863,279.149384 
	C373.643402,279.857452 373.770081,280.422272 373.908112,281.317444 
	C373.912689,282.088348 373.905914,282.528931 373.575531,283.031982 
	C371.785492,287.086151 374.648285,287.825470 377.341003,287.924438 
	C383.628357,288.155518 389.937683,288.162567 396.219482,287.865875 
	C397.528656,287.804016 398.757324,286.038116 400.037048,284.636353 
	C400.038574,278.801361 400.026154,273.387512 400.013855,267.575012 
	C400.323303,265.458496 400.632599,263.740601 401.135315,262.325562 
	C401.550720,264.085266 401.772675,265.542114 401.994629,266.998962 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M211.663681,434.014343 
	C211.433289,434.682037 210.741501,435.923340 210.166382,435.871429 
	C203.054352,435.229736 197.022217,438.530029 190.376862,440.992737 
	C192.688629,438.088104 193.719711,434.887329 193.158356,430.715149 
	C192.643250,426.886719 194.890411,424.522919 199.205887,424.978912 
	C200.512070,425.116943 201.848145,425.058319 203.165314,424.989502 
	C207.006927,424.788818 209.005478,426.328613 209.110977,430.420349 
	C209.142105,431.626892 210.504303,432.799103 211.663681,434.014343 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M252.698914,438.707703 
	C252.862030,433.113770 253.025146,427.519806 253.098877,421.465576 
	C253.783081,420.323059 254.556702,419.640839 255.911926,418.961639 
	C256.667206,418.924072 256.840851,418.883484 257.014496,418.842896 
	C257.448792,418.890411 257.883087,418.937897 259.061371,419.016174 
	C261.778961,419.070496 263.752594,419.094025 265.726196,419.117554 
	C265.833862,419.528595 265.941559,419.939636 266.071289,421.117188 
	C266.093353,427.129669 266.093353,432.375641 266.093353,437.760742 
	C270.715118,438.270538 274.781219,438.719055 278.847321,439.167572 
	C278.847321,439.167572 278.959045,439.010803 278.870148,439.508057 
	C278.708191,442.589600 278.635132,445.173889 278.562042,447.758209 
	C278.217957,447.923828 277.873901,448.089478 277.275024,448.388855 
	C276.842590,448.399872 276.664948,448.277100 276.269836,447.654236 
	C276.370453,446.105621 276.688568,445.057068 276.995331,443.595276 
	C276.121643,439.220428 272.966125,441.206635 270.872864,441.047638 
	C265.693787,440.654297 264.136475,439.308746 264.042358,434.100769 
	C263.991547,431.288330 264.455475,428.381012 263.869873,425.694702 
	C263.495453,423.977142 261.627777,422.585114 260.429565,421.047150 
	C259.147919,422.252808 257.327393,423.237549 256.719818,424.719574 
	C255.944901,426.609772 256.502838,429.019226 255.846085,430.991669 
	C254.974289,433.609863 256.761658,437.401093 252.698914,438.707703 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M402.362000,266.998230 
	C401.772675,265.542114 401.550720,264.085266 401.173584,261.987244 
	C400.934174,260.902191 400.849976,260.458313 400.832855,259.614136 
	C399.463348,254.086578 398.026764,248.959366 396.556641,243.588867 
	C396.523102,243.345581 396.290314,242.913086 396.290314,242.913086 
	C393.261200,238.229813 390.232086,233.546539 387.060730,228.574097 
	C388.850891,228.519958 391.319366,228.097351 392.595367,229.137527 
	C394.738068,230.884232 396.548065,233.364883 397.718079,235.897095 
	C399.202515,239.109711 399.962067,242.667114 400.921204,246.107361 
	C401.269684,247.357422 401.134125,248.743988 401.493408,249.989227 
	C402.742645,254.319046 404.190948,258.592712 405.376129,262.938812 
	C405.648285,263.936951 405.173004,265.138916 404.984009,266.616699 
	C404.194000,266.990051 403.461670,266.993744 402.362000,266.998230 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M177.968277,470.981323 
	C177.964203,471.421082 177.960144,471.860840 177.957382,472.629639 
	C177.958694,472.958710 177.982254,472.973724 177.655945,473.014862 
	C176.889709,473.704407 176.449768,474.352814 176.009796,475.001190 
	C175.427261,477.432709 174.844727,479.864197 174.090759,482.963989 
	C173.592758,484.408478 173.266159,485.184631 172.939545,485.960785 
	C169.853210,488.604523 166.766876,491.248260 162.936493,493.930176 
	C160.101486,494.963013 158.010529,495.957733 155.919556,496.952454 
	C153.088303,497.135803 150.257050,497.319153 147.204956,497.230988 
	C151.647156,494.942291 156.576584,493.376709 160.918594,490.815369 
	C170.387375,485.229736 174.647858,476.035675 177.352295,465.413910 
	C177.860519,467.078033 177.914398,469.029663 177.968277,470.981323 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M324.960083,453.014893 
	C323.055023,452.820374 321.149963,452.625854 319.020386,452.408417 
	C316.330353,447.821777 311.882172,447.664307 307.694977,451.640106 
	C306.129547,453.126465 303.278290,453.339844 300.961243,453.928711 
	C298.963348,454.436493 296.891479,454.653351 294.464294,455.064545 
	C293.152435,452.251709 286.694550,451.496338 290.242828,445.385071 
	C290.771362,445.034637 290.961975,445.048615 291.181519,445.418274 
	C293.915924,453.147064 294.517670,453.406067 299.642517,449.326660 
	C299.787811,449.312469 300.022339,449.132355 300.420258,449.127441 
	C305.822540,448.339264 310.814911,447.052551 315.835083,446.933044 
	C319.800995,446.838623 323.604218,448.466949 324.960083,453.014893 
M303.405731,450.694916 
	C303.626678,450.991547 303.847656,451.288208 304.068604,451.584839 
	C304.257996,451.403656 304.447357,451.222473 304.636719,451.041260 
	C304.349640,450.808105 304.062561,450.574951 303.405731,450.694916 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M451.542328,497.514069 
	C451.288300,497.605438 451.034302,497.696808 450.390167,497.896515 
	C443.644470,492.719727 438.036926,496.731689 432.761444,499.845459 
	C427.054291,503.213989 421.917694,502.607208 416.317719,498.851959 
	C416.024048,497.813965 416.031097,497.345306 416.454376,496.920166 
	C428.174316,500.020416 437.970398,497.181885 446.039368,489.179749 
	C448.032745,492.198792 449.787537,494.856415 451.542328,497.514069 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M325.135376,453.314880 
	C323.604218,448.466949 319.800995,446.838623 315.835083,446.933044 
	C310.814911,447.052551 305.822540,448.339264 300.452332,448.745911 
	C300.545197,447.710236 300.868042,446.670074 301.483551,446.450623 
	C308.324005,444.010986 315.347900,442.958862 322.266052,445.774078 
	C329.705170,448.801300 332.265350,458.402466 327.215698,463.217651 
	C327.215698,463.217651 327.087067,463.088959 327.009827,462.624268 
	C326.518005,459.754761 326.103485,457.349976 325.688965,454.945160 
	C325.562866,454.501740 325.436798,454.058319 325.135376,453.314880 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M402.451599,299.122192 
	C403.239258,298.953369 403.731720,298.974060 404.592163,299.002777 
	C405.355133,303.367615 402.421570,304.129364 399.076996,304.496857 
	C396.520721,304.777740 393.971832,305.126373 391.173767,305.727722 
	C389.741669,305.717621 388.555511,305.424652 386.746307,305.179382 
	C385.783966,305.268036 385.444672,305.308960 385.105377,305.349884 
	C383.348938,305.227844 381.592499,305.105835 379.461365,304.991577 
	C375.883545,304.278717 372.651825,303.657654 369.501373,302.753571 
	C368.870880,302.572662 368.550018,301.312775 368.116760,300.143677 
	C377.853912,303.847046 387.996460,301.422699 397.952881,301.589142 
	C399.340973,301.612366 400.754578,300.108643 402.451599,299.122192 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M362.580963,252.256836 
	C364.398956,255.169174 366.216949,258.081512 368.055115,261.674683 
	C368.386414,262.905975 368.697571,263.456421 369.008728,264.006897 
	C369.008728,264.006897 369.158875,264.327789 369.103821,264.921631 
	C369.480469,267.345978 369.912170,269.176514 370.343872,271.007019 
	C370.335663,273.374725 370.327454,275.742432 369.955902,278.718231 
	C369.371277,280.244476 369.149963,281.162598 368.928619,282.080750 
	C367.979767,278.682861 365.717285,275.006500 366.365906,271.947296 
	C367.575043,266.244476 364.315857,262.591583 362.307587,258.269226 
	C361.290497,256.080170 360.090057,253.976288 359.316040,251.406754 
	C359.893433,250.989853 360.127258,251.000107 360.339233,251.006897 
	C360.317352,251.003464 360.271576,250.992706 360.560974,251.160736 
	C361.427246,251.638107 362.004089,251.947464 362.580963,252.256836 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M278.877869,438.817200 
	C274.781219,438.719055 270.715118,438.270538 266.093353,437.760742 
	C266.093353,432.375641 266.093353,427.129669 266.175964,421.418335 
	C267.164520,422.275146 268.733002,423.532928 268.868713,424.929932 
	C269.739258,433.890747 269.635956,433.900787 278.575989,434.094330 
	C278.687592,435.562073 278.798004,437.014435 278.877869,438.817200 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M360.361084,251.010345 
	C360.127258,251.000107 359.893433,250.989853 359.312500,251.032928 
	C358.244629,250.543564 357.523926,250.000870 356.212402,249.154053 
	C353.734467,248.614624 351.847382,248.379303 349.960266,248.143997 
	C349.528534,248.072845 349.096771,248.001694 348.350037,247.837387 
	C341.997559,247.902298 335.960114,248.060364 329.476257,247.877701 
	C329.025208,247.065964 329.020569,246.594925 329.263702,245.829041 
	C334.724701,245.360596 339.953827,244.859634 345.146393,245.111847 
	C349.711548,245.333603 354.270966,246.240799 358.744812,247.239792 
	C359.528534,247.414795 359.877045,249.538940 360.424255,250.816086 
	C360.421936,250.869278 360.361084,251.010345 360.361084,251.010345 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M325.267578,454.978088 
	C326.103485,457.349976 326.518005,459.754761 326.945160,462.560242 
	C318.945709,462.728363 310.933624,462.495819 302.488892,462.235168 
	C302.906158,461.168060 303.716736,459.270294 304.612366,459.229279 
	C310.502991,458.959534 316.411987,459.090118 322.701447,459.090118 
	C323.057037,458.413818 323.951599,456.712433 325.267578,454.978088 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M390.960846,355.810883 
	C391.203003,355.212921 391.368469,354.140198 391.698669,354.086823 
	C398.907104,352.921783 403.434052,346.883301 409.794586,344.217133 
	C409.944336,344.154388 410.112793,344.136200 410.632568,344.057831 
	C415.432648,343.664459 417.731812,345.420898 417.033661,350.554962 
	C416.820374,351.241943 416.599884,351.513123 416.117310,351.507843 
	C414.344788,345.612671 411.803802,345.181702 407.107056,348.156219 
	C402.112335,351.319397 396.374298,353.308868 390.960846,355.810883 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M313.009338,191.968002 
	C314.304352,191.586533 315.599365,191.205063 317.230530,190.842880 
	C318.181152,191.269714 319.385529,191.873032 319.324646,192.056412 
	C317.306946,198.135483 315.168243,204.174377 312.583923,210.583771 
	C311.854340,210.936737 311.588104,210.925110 311.321899,210.913498 
	C311.316711,208.959167 311.311523,207.004822 311.732422,204.422638 
	C313.061615,201.303177 314.534454,198.705872 310.907867,197.054749 
	C310.907867,197.054749 310.989258,197.017288 310.942444,196.720795 
	C310.400177,195.508286 309.904755,194.592270 309.442841,193.738190 
	C310.792358,193.068375 311.900848,192.518188 313.009338,191.968002 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M299.497192,449.340881 
	C294.517670,453.406067 293.915924,453.147064 291.465698,445.259216 
	C293.488831,443.517120 295.256714,442.289703 297.024567,441.062256 
	C297.577576,440.902405 298.130615,440.742584 299.211243,440.361145 
	C300.262787,439.772827 300.786774,439.406067 301.310730,439.039307 
	C302.077545,439.006317 302.844360,438.973297 304.068359,438.913208 
	C304.525543,438.886139 305.012115,438.996979 304.963928,439.332642 
	C301.713287,442.092621 298.510803,444.516998 294.663513,447.429474 
	C296.859833,448.297974 298.178528,448.819397 299.497192,449.340881 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M372.150452,508.581696 
	C375.137146,508.267487 377.797363,507.995667 380.424316,508.185181 
	C381.265381,508.245880 382.562531,509.463867 382.656219,510.268188 
	C382.746887,511.046692 381.594849,512.679138 380.924103,512.714600 
	C377.974426,512.870361 374.922668,512.955261 372.060211,512.347900 
	C369.469604,511.798248 370.271667,510.120972 372.150452,508.581696 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M187.389740,490.290100 
	C187.572769,491.692596 187.752609,492.951447 187.977097,494.592712 
	C187.860901,495.006836 187.700684,495.042114 187.539154,495.069641 
	C185.180923,495.471466 181.419479,496.964172 180.724304,496.070892 
	C178.540833,493.265228 181.187012,491.107330 184.020447,489.280518 
	C185.488022,489.491394 186.330688,489.722595 187.173340,489.953796 
	C187.173340,489.953796 187.386566,490.146454 187.389740,490.290100 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M232.477875,257.037354 
	C232.777267,263.104675 236.966919,263.176880 241.668427,263.265961 
	C237.109360,266.795563 230.873718,266.436340 229.996658,260.605682 
	C229.835464,259.534180 231.328293,258.213867 232.477875,257.037354 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M330.308533,495.368805 
	C330.079437,495.758423 329.850311,496.148041 329.347504,496.738251 
	C326.604095,493.441132 324.094482,495.681000 321.212128,496.921997 
	C320.628998,496.939209 320.425812,496.921204 319.919708,496.856812 
	C321.975037,494.493896 324.333252,492.177368 327.190186,489.536133 
	C328.094727,489.225861 328.500580,489.240326 328.905640,489.547668 
	C328.991821,490.221039 329.078735,490.601471 329.125854,491.316956 
	C329.493561,492.890930 329.901062,494.129883 330.308533,495.368805 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M296.844666,440.715881 
	C295.256714,442.289703 293.488831,443.517120 291.436768,444.903564 
	C290.961975,445.048615 290.771362,445.034637 290.294312,445.010254 
	C289.405090,443.348267 288.802277,441.696716 287.657013,438.558777 
	C291.347839,439.300720 294.006317,439.835144 296.844666,440.715881 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M183.039032,475.338135 
	C184.479202,473.023773 185.941666,471.045563 187.773804,469.090546 
	C187.085312,473.785858 186.027161,478.457916 184.625977,483.418213 
	C183.851761,482.803528 183.420563,481.900665 182.989365,480.997803 
	C183.013351,479.223297 183.037323,477.448761 183.039032,475.338135 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M311.191956,211.280975 
	C311.588104,210.925110 311.854340,210.936737 312.518219,210.977631 
	C312.938080,211.462341 312.960327,211.917770 312.991943,213.056427 
	C313.625153,214.495285 314.249054,215.250931 314.872925,216.006561 
	C314.892853,216.186111 314.912811,216.365677 314.956360,216.816223 
	C314.987305,217.776733 314.994659,218.466217 315.004059,219.500702 
	C312.159363,220.493332 310.705750,219.556610 310.972412,216.443741 
	C311.108551,214.854416 311.038727,213.247437 311.191956,211.280975 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M526.024414,488.985626 
	C526.960083,489.593414 527.895813,490.201233 528.831482,490.809052 
	C527.137756,492.535034 525.444092,494.261017 523.376099,495.658447 
	C523.002014,494.886139 523.002197,494.442474 523.301147,493.845459 
	C524.408081,492.123260 525.216248,490.554443 526.024414,488.985626 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M278.953735,447.790955 
	C278.635132,445.173889 278.708191,442.589600 278.800537,439.574524 
	C282.861847,441.399628 283.011688,443.874054 278.953735,447.790955 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M349.979065,248.522186 
	C351.847382,248.379303 353.734467,248.614624 355.875366,249.078735 
	C354.447815,250.406982 352.766449,251.506439 350.570526,252.942398 
	C350.333618,251.270248 350.165771,250.085312 349.979065,248.522186 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M313.918579,173.555847 
	C313.725189,171.867584 313.882660,170.341766 314.013000,168.414886 
	C315.576202,168.862762 317.166565,169.711731 319.654510,171.039856 
	C317.221771,172.249863 315.745605,172.984085 313.918579,173.555847 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M156.358643,496.969727 
	C158.010529,495.957733 160.101486,494.963013 162.593018,493.970215 
	C162.875107,498.977936 159.016846,496.298187 156.358643,496.969727 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M173.293427,486.007263 
	C173.266159,485.184631 173.592758,484.408478 173.945969,483.315308 
	C175.781174,484.445770 177.589737,485.893158 179.398315,487.340576 
	C179.044144,487.811035 178.689987,488.281494 178.335831,488.751953 
	C176.772980,487.852570 175.210129,486.953156 173.293427,486.007263 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M525.713623,488.970642 
	C525.216248,490.554443 524.408081,492.123260 522.982056,493.816711 
	C521.881409,493.569824 521.398682,493.198364 520.915894,492.826904 
	C521.999756,491.569336 523.083618,490.311737 524.474243,488.993805 
	C524.988342,488.940887 525.195618,488.948273 525.713623,488.970642 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M266.010712,418.912598 
	C263.752594,419.094025 261.778961,419.070496 259.385437,418.957184 
	C261.711304,416.296356 264.150635,416.243164 266.010712,418.912598 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M263.371826,189.442352 
	C263.217987,189.858719 262.984772,189.891815 262.400146,189.955597 
	C260.382141,187.286896 259.875854,184.809219 263.751923,183.106827 
	C263.856354,185.098740 263.574371,187.078903 263.371826,189.442352 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M182.641907,481.003845 
	C183.420563,481.900665 183.851761,482.803528 184.553070,483.859070 
	C185.062866,484.801208 185.302551,485.590668 185.191132,486.718140 
	C184.549683,487.036163 184.259338,487.016266 183.968994,486.996338 
	C182.983963,485.775513 181.822800,484.645844 181.116119,483.280884 
	C180.890091,482.844269 181.867615,481.784515 182.641907,481.003845 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M466.005981,516.337036 
	C467.224426,515.385376 468.441498,514.765320 469.918671,514.012756 
	C469.414673,515.888245 471.999634,519.714233 466.364258,518.032837 
	C466.005585,517.552979 466.005096,517.110840 466.005981,516.337036 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M336.630554,433.004761 
	C336.413757,434.273315 335.827515,435.546631 335.241272,436.819946 
	C334.621826,436.361908 334.002411,435.903839 333.382965,435.445801 
	C334.342346,434.633698 335.301727,433.821594 336.630554,433.004761 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M354.003357,348.428894 
	C354.634674,347.787231 355.260468,347.560028 356.125122,347.743225 
	C356.320648,349.735992 356.277283,351.318329 356.233948,352.900696 
	C355.741089,352.928558 355.248230,352.956421 354.385376,352.986877 
	C354.009552,351.607422 354.003693,350.225372 354.003357,348.428894 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M411.377869,496.989990 
	C411.009949,496.183411 411.015533,495.381195 411.400635,494.260986 
	C412.980377,494.870178 414.180664,495.797333 415.036224,496.813049 
	C414.458618,496.947083 414.225769,496.992615 413.992889,497.038147 
	C413.245728,497.023529 412.498535,497.008942 411.377869,496.989990 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M520.610107,492.925659 
	C521.398682,493.198364 521.881409,493.569824 522.683289,493.970032 
	C523.002197,494.442474 523.002014,494.886139 523.002136,495.662476 
	C521.777161,495.659027 520.551941,495.322968 518.982666,494.917297 
	C519.193970,494.239960 519.749146,493.632172 520.610107,492.925659 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M481.345276,528.988403 
	C481.072693,527.913574 481.136841,526.839355 481.200958,525.765137 
	C481.670624,525.399475 482.140259,525.033813 482.609924,524.668213 
	C482.980530,525.586975 483.351135,526.505737 483.857086,527.709839 
	C483.222260,528.326416 482.452118,528.657776 481.345276,528.988403 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M368.943573,282.430054 
	C369.149963,281.162598 369.371277,280.244476 369.889893,279.123779 
	C370.034698,280.519104 369.882202,282.117004 369.492218,283.929169 
	C369.156006,283.688721 369.057251,283.234039 368.943573,282.430054 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M314.901703,215.656342 
	C314.249054,215.250931 313.625153,214.495285 312.993744,213.398514 
	C313.634308,213.806961 314.282410,214.556549 314.901703,215.656342 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M183.984589,487.329163 
	C184.259338,487.016266 184.549683,487.036163 185.275925,487.122192 
	C186.187561,487.926178 186.663300,488.664032 187.156189,489.677856 
	C186.330688,489.722595 185.488022,489.491394 184.341095,489.127014 
	C184.024612,488.549866 184.012390,488.105927 183.984589,487.329163 
z"/>
<path fill="#F7FDFC" opacity="1.000000" stroke="none" 
	d="
M414.038452,497.356201 
	C414.225769,496.992615 414.458618,496.947083 415.203003,496.836243 
	C415.714508,496.770905 416.038116,496.876678 416.038147,496.876678 
	C416.031097,497.345306 416.024048,497.813965 416.021149,498.633820 
	C415.378204,498.548126 414.731140,498.111176 414.038452,497.356201 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M188.055634,495.304932 
	C188.662155,495.430542 189.302444,495.882782 189.994476,496.653320 
	C189.393951,496.524933 188.741684,496.078217 188.055634,495.304932 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M368.932556,284.169769 
	C369.129639,284.764923 368.999481,285.314972 368.590759,285.977844 
	C368.409882,285.435333 368.507599,284.779999 368.932556,284.169769 
z"/>
<path fill="#FCFDF9" opacity="1.000000" stroke="none" 
	d="
M176.331635,474.958374 
	C176.449768,474.352814 176.889709,473.704407 177.648285,473.010376 
	C177.529114,473.614990 177.091293,474.265289 176.331635,474.958374 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M300.923279,439.024323 
	C300.786774,439.406067 300.262787,439.772827 299.404541,440.142700 
	C299.045044,439.954834 299.019775,439.763916 298.992188,439.284058 
	C299.505188,438.999847 300.020538,439.004608 300.923279,439.024323 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M297.748413,502.359192 
	C297.994049,502.374054 298.127167,502.503143 298.260254,502.632233 
	C298.052124,502.579285 297.844025,502.526337 297.748413,502.359192 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M528.128296,483.774719 
	C527.994385,483.557587 528.136719,483.222778 528.499268,482.716217 
	C528.614441,482.915344 528.509460,483.286194 528.128296,483.774719 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M527.242065,484.891632 
	C527.145630,484.699219 527.279419,484.393860 527.644165,483.977356 
	C527.740784,484.170349 527.606567,484.474518 527.242065,484.891632 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M516.173218,495.923767 
	C516.016174,495.633575 516.208923,495.388489 516.768494,495.228729 
	C516.891479,495.513855 516.687439,495.732147 516.173218,495.923767 
z"/>
<path fill="#EFF6DC" opacity="1.000000" stroke="none" 
	d="
M256.924347,418.686218 
	C256.840851,418.883484 256.667206,418.924072 256.240143,418.878479 
	C256.269196,418.704712 256.551697,418.617126 256.924347,418.686218 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M416.454346,496.920166 
	C416.038116,496.876678 415.714508,496.770905 415.547729,496.747681 
	C414.180664,495.797333 412.980377,494.870178 411.453918,493.862183 
	C410.670654,493.201660 410.213623,492.622009 409.378632,491.610443 
	C407.875885,486.095947 406.751099,481.013367 405.626282,475.930786 
	C405.691284,475.775543 405.756226,475.620270 406.122070,475.226379 
	C406.422913,474.987701 406.853760,474.941772 407.144104,474.961426 
	C407.627991,474.988922 407.821564,474.996796 408.015076,475.448242 
	C406.600098,487.925293 414.387787,493.187256 421.664764,495.605560 
	C428.055145,497.729279 438.094696,494.032104 440.751221,488.772614 
	C438.708405,489.319275 437.209015,489.730225 435.704468,490.121429 
	C429.723602,491.676361 424.015045,491.988892 418.869751,487.527618 
	C413.641632,482.994598 415.009125,470.494446 421.365906,468.501617 
	C425.736847,467.131317 430.436890,466.810822 435.234589,466.300018 
	C437.555786,467.061005 439.731415,467.304199 441.673584,468.109955 
	C442.948181,468.638733 443.885437,469.980469 444.583923,470.927490 
	C438.478027,470.287994 432.748627,469.102539 427.049805,469.234558 
	C421.499695,469.363098 416.965607,474.619080 417.143280,479.225952 
	C417.337677,484.266083 422.195892,488.616455 427.990784,488.939545 
	C439.692078,489.591980 445.292755,483.707642 445.403961,471.083740 
	C448.893341,473.543732 448.128021,476.549927 447.244476,479.695801 
	C446.723419,481.550903 445.687775,484.230804 446.506348,485.318726 
	C449.453125,489.235168 453.089630,492.632629 457.364441,497.183014 
	C457.730316,494.441681 458.070343,493.340240 457.989563,492.270538 
	C457.343689,483.718048 456.952301,475.126862 455.816620,466.636658 
	C454.819122,459.179596 455.881958,450.865784 448.693573,445.369873 
	C447.583069,444.520844 446.862671,443.161560 446.324432,442.021027 
	C447.170807,441.980652 447.654633,441.957489 448.445374,442.070862 
	C453.568848,444.975098 456.311951,449.468323 456.818848,454.647217 
	C457.667755,463.320068 457.467255,472.091217 458.067505,480.796234 
	C458.199585,482.711548 459.834320,484.523224 460.777130,486.382629 
	C460.844086,486.747772 460.911041,487.112915 460.996094,488.176117 
	C461.062866,490.916504 461.111481,492.958862 461.160126,495.001190 
	C459.363464,499.730225 455.418732,497.268921 451.931519,497.578003 
	C449.787537,494.856415 448.032745,492.198792 446.039368,489.179749 
	C437.970398,497.181885 428.174316,500.020416 416.454346,496.920166 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M474.005310,433.423645 
	C475.238831,433.300629 476.495636,433.507172 477.689667,433.903107 
	C479.073700,434.362091 480.402527,434.987427 482.376007,434.520447 
	C482.929596,436.017975 483.142883,437.823975 484.137787,438.921417 
	C485.032806,439.908691 487.283478,440.978149 488.072632,440.520935 
	C491.316864,438.641235 494.200226,436.148651 497.276611,433.966522 
	C500.306885,431.817108 500.993835,433.577179 500.994751,436.731354 
	C497.756317,438.296570 494.327606,439.095703 491.338043,440.708710 
	C488.556152,442.209686 486.242004,444.577576 483.442139,446.784332 
	C483.122589,444.719696 482.876251,443.127991 482.440857,440.919952 
	C481.860931,439.863678 481.470062,439.423737 480.776154,438.746033 
	C478.040405,438.698425 475.607727,438.888580 472.830994,439.313354 
	C472.372375,443.347717 472.257843,447.147430 472.062073,451.367889 
	C472.035339,453.209930 472.089874,454.631256 472.080383,456.513977 
	C472.050812,465.298126 472.085266,473.620850 472.037231,482.401917 
	C472.017853,486.258423 472.080994,489.656586 472.081665,493.515961 
	C472.061096,500.299377 472.103027,506.621613 472.067383,513.380554 
	C471.917603,515.882507 471.845398,517.947815 471.773163,520.013062 
	C471.512817,518.088623 471.043915,516.165894 471.027466,514.239380 
	C470.948181,504.954407 472.236084,495.455872 470.696045,486.432983 
	C468.431976,473.168030 472.660828,460.020996 469.965363,446.945679 
	C469.316162,443.796417 468.296722,440.723511 467.257568,436.920227 
	C468.440094,435.257904 474.009613,439.725494 474.005310,433.423645 
z"/>
<path fill="#6EAFD4" opacity="1.000000" stroke="none" 
	d="
M443.186218,452.932526 
	C442.768127,452.286896 442.350067,451.641266 441.530151,450.552063 
	C437.417694,449.060486 433.707062,448.012482 429.996460,446.964478 
	C428.938416,446.998779 427.880371,447.033081 426.065063,447.094788 
	C423.043335,448.314117 420.778900,449.506042 418.514465,450.697937 
	C418.170197,450.729431 417.825958,450.760956 416.926758,450.898010 
	C415.552185,451.574799 414.732574,452.146057 413.912964,452.717316 
	C413.073883,452.302887 412.234833,451.888458 411.235168,450.890778 
	C410.444397,449.189514 409.814209,448.071503 409.184021,446.953491 
	C409.680725,445.870972 410.177399,444.788452 411.250488,443.391052 
	C415.899445,441.409821 419.971985,439.743408 424.044525,438.076965 
	C424.471588,438.010315 424.898651,437.943665 426.066345,437.886719 
	C428.872131,437.926575 430.937286,437.956757 433.001312,438.312561 
	C432.998444,439.072205 432.996735,439.506287 432.760468,440.223755 
	C426.657745,439.019958 421.547882,441.048401 416.808502,444.176636 
	C415.521820,445.025909 414.785583,446.709015 413.796692,448.009430 
	C414.184052,448.364288 414.571411,448.719177 414.958801,449.074036 
	C416.145813,448.623962 417.519653,448.419952 418.489441,447.683716 
	C424.622833,443.027588 431.387177,443.324341 438.202515,445.294708 
	C444.623657,447.151093 449.332855,455.189178 447.679047,461.110565 
	C447.440552,461.964508 446.030945,462.491394 445.126648,463.131683 
	C445.089966,463.093719 445.017090,463.017303 445.047821,462.679932 
	C445.057312,461.892975 445.036072,461.443390 445.014832,460.993805 
	C445.035095,460.553558 445.055359,460.113342 445.064911,458.972290 
	C444.431549,456.491821 443.808899,454.712189 443.186218,452.932526 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M471.933228,520.244141 
	C471.845398,517.947815 471.917603,515.882507 472.422058,513.476196 
	C473.235474,513.983093 473.846283,514.801941 473.957825,515.683960 
	C474.427307,519.395752 476.726776,519.722046 479.266113,518.197266 
	C480.552338,517.424988 481.835815,515.484131 481.891907,514.024475 
	C482.164642,506.928070 481.867889,499.809937 482.136627,492.713257 
	C482.201965,490.987701 483.643127,489.314270 484.451691,487.616852 
	C485.009766,488.029358 485.567871,488.441864 486.125946,488.854370 
	C486.125946,488.854370 486.062073,488.928589 485.705597,489.215302 
	C485.202881,491.999420 485.056671,494.496826 484.910431,496.994232 
	C484.853088,499.015350 484.795746,501.036438 484.564453,503.840088 
	C484.317108,506.093292 484.186676,507.563629 484.179382,509.034576 
	C484.121979,520.614014 484.129211,520.614075 472.997620,521.130981 
	C472.696167,520.912415 472.394714,520.693787 471.933228,520.244141 
z"/>
<path fill="#6EAFD4" opacity="1.000000" stroke="none" 
	d="
M439.012299,461.834412 
	C439.439270,461.915710 439.866241,461.997040 440.859131,462.379578 
	C442.622406,462.792969 443.819763,462.905121 445.017090,463.017303 
	C445.017090,463.017303 445.089966,463.093719 444.993774,463.478577 
	C443.264465,464.068756 441.633453,464.292786 439.997681,464.474274 
	C438.328766,464.659393 436.655182,464.802704 434.572968,464.917389 
	C427.159119,463.316010 420.467590,462.951019 414.656586,468.470459 
	C413.243927,469.812225 410.867126,470.138855 408.934998,470.615540 
	C408.978058,469.879211 409.019745,469.459656 409.061432,469.040100 
	C409.061432,469.040100 409.009735,468.994293 409.328674,468.888916 
	C411.528534,467.246399 413.409424,465.709290 415.290283,464.172180 
	C415.290314,464.172211 415.662354,464.138855 416.151581,464.041260 
	C417.273926,463.415710 417.907074,462.887817 418.540192,462.359863 
	C419.465698,462.288757 420.391235,462.217651 421.937988,462.037048 
	C422.854095,461.698944 423.148956,461.470306 423.443817,461.241699 
	C427.308014,461.231384 431.172180,461.221100 435.737488,461.420349 
	C437.296478,461.698029 438.154388,461.766205 439.012299,461.834412 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M473.048706,521.503845 
	C484.129211,520.614075 484.121979,520.614014 484.179382,509.034576 
	C484.186676,507.563629 484.317108,506.093292 484.606995,504.271210 
	C485.221375,506.101410 485.435333,508.338715 486.073792,510.447540 
	C486.611542,512.223755 488.446045,513.922302 488.302704,515.530029 
	C487.894287,520.110229 485.466919,523.412964 480.491577,524.129089 
	C480.180420,524.173889 479.795868,524.293152 479.606659,524.515198 
	C474.766602,530.195251 474.239594,525.284729 473.048706,521.503845 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M460.841919,485.983398 
	C459.834320,484.523224 458.199585,482.711548 458.067505,480.796234 
	C457.467255,472.091217 457.667755,463.320068 456.818848,454.647217 
	C456.311951,449.468323 453.568848,444.975098 448.265381,441.795471 
	C446.488312,440.630920 445.198212,439.878235 443.958954,439.064148 
	C444.009766,439.002747 444.116699,438.884613 444.116699,438.884613 
	C452.927551,439.454193 457.959229,444.618225 458.308319,453.365143 
	C458.347015,454.334167 458.751740,455.288574 458.992249,457.024994 
	C459.005127,458.867157 459.012421,459.934052 459.019714,461.000977 
	C459.017639,462.067139 459.015533,463.133270 459.010437,465.065613 
	C459.332764,470.957001 459.658081,475.982147 459.983398,481.007324 
	C460.291168,482.532928 460.598969,484.058533 460.841919,485.983398 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M497.137756,497.965332 
	C502.096466,497.566437 507.010986,497.621521 512.375061,497.603210 
	C512.559875,498.572052 512.306702,500.518555 512.028625,500.522095 
	C507.195435,500.583984 502.358337,500.426331 497.527191,500.204834 
	C497.355713,500.196991 497.236908,499.040497 497.137756,497.965332 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M405.286896,476.019409 
	C406.751099,481.013367 407.875885,486.095947 409.093109,491.540619 
	C408.548981,491.774200 407.774567,491.834747 407.297760,491.487091 
	C403.728760,488.885010 402.312256,479.363037 405.286896,476.019409 
z"/>
<path fill="#F4FBFC" opacity="1.000000" stroke="none" 
	d="
M460.283569,480.715637 
	C459.658081,475.982147 459.332764,470.957001 459.016296,465.465393 
	C459.677521,465.769775 460.880768,466.533447 460.890869,467.312561 
	C460.947601,471.680939 460.716522,476.053070 460.283569,480.715637 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M485.333252,496.996918 
	C485.056671,494.496826 485.202881,491.999420 485.673920,489.252625 
	C487.252991,490.395111 488.507263,491.787018 489.919373,493.439758 
	C490.344177,497.036560 488.164185,497.167511 485.333252,496.996918 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M423.816467,437.788574 
	C419.971985,439.743408 415.899445,441.409821 411.468842,443.145599 
	C412.260925,441.830261 413.154663,439.745026 414.615845,439.210327 
	C417.437469,438.177826 420.579346,438.020355 423.816467,437.788574 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M433.002441,437.986938 
	C430.937286,437.956757 428.872131,437.926575 426.375549,437.784668 
	C430.071899,434.574249 434.435028,435.850494 438.495300,437.446533 
	C436.467651,437.936432 434.735046,437.961700 433.002441,437.986938 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M430.068573,447.338776 
	C433.707062,448.012482 437.417694,449.060486 441.239197,450.466553 
	C437.613617,449.787445 433.877136,448.750244 430.068573,447.338776 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M433.001312,438.312561 
	C434.735046,437.961700 436.467651,437.936432 438.625122,437.815613 
	C439.481689,437.793823 439.913361,437.867645 440.686523,438.152893 
	C441.028046,438.364319 441.098663,438.754272 441.069244,439.119415 
	C441.030609,439.969849 441.021423,440.455170 440.614990,440.906006 
	C437.810181,440.561157 435.402588,440.250732 432.995026,439.940308 
	C432.996735,439.506287 432.998444,439.072205 433.001312,438.312561 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M414.854614,464.115082 
	C413.409424,465.709290 411.528534,467.246399 409.346008,468.918427 
	C408.445496,464.816345 410.597656,463.539215 414.854614,464.115082 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M461.445251,494.828796 
	C461.111481,492.958862 461.062866,490.916504 461.083008,488.441223 
	C465.526093,489.860382 463.694214,492.252655 461.445251,494.828796 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M418.921051,450.783081 
	C420.778900,449.506042 423.043335,448.314117 425.673859,447.164673 
	C423.802521,448.427490 421.565063,449.647858 418.921051,450.783081 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M442.891785,453.136200 
	C443.808899,454.712189 444.431549,456.491821 445.010071,458.645630 
	C444.176422,457.126495 443.386902,455.233185 442.891785,453.136200 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M445.047821,462.679932 
	C443.819763,462.905121 442.622406,462.792969 441.183960,462.412598 
	C442.048798,461.762207 443.154755,461.379974 444.637756,460.995789 
	C445.036072,461.443390 445.057312,461.892975 445.047821,462.679932 
z"/>
<path fill="#F4FBFC" opacity="1.000000" stroke="none" 
	d="
M459.364380,460.938904 
	C459.012421,459.934052 459.005127,458.867157 459.001129,457.400116 
	C461.766479,457.832977 461.663849,459.186615 459.364380,460.938904 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M441.098663,438.754272 
	C441.098663,438.754272 441.028046,438.364319 441.015961,438.166382 
	C441.406891,437.436523 441.809906,436.904602 442.212891,436.372681 
	C442.796814,437.001404 443.380707,437.630157 444.040649,438.571777 
	C444.116699,438.884613 444.009766,439.002747 443.607880,439.021851 
	C442.503540,438.945404 441.801117,438.849823 441.098663,438.754272 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M408.909821,447.127441 
	C409.814209,448.071503 410.444397,449.189514 411.076141,450.637939 
	C410.263702,449.746033 409.449646,448.523682 408.909821,447.127441 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M414.070618,453.006592 
	C414.732574,452.146057 415.552185,451.574799 416.685669,450.996704 
	C416.075806,451.758575 415.152069,452.527252 414.070618,453.006592 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M438.861664,461.574615 
	C438.154388,461.766205 437.296478,461.698029 436.192596,461.416565 
	C436.868103,461.240448 437.789551,461.277618 438.861664,461.574615 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M408.715454,469.070374 
	C409.019745,469.459656 408.978058,469.879211 408.947510,470.626648 
	C408.958618,470.954559 408.951782,470.958618 408.688538,471.048889 
	C407.947235,471.423859 407.469177,471.708527 406.960114,471.969727 
	C406.929108,471.946198 406.864929,471.902100 406.864929,471.902100 
	C407.366455,470.968292 407.867981,470.034454 408.715454,469.070374 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M418.176208,462.278137 
	C417.907074,462.887817 417.273926,463.415710 416.319366,463.959229 
	C416.602692,463.381989 417.207458,462.789185 418.176208,462.278137 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M406.853760,474.941772 
	C406.853760,474.941772 406.422913,474.987701 406.206177,474.988342 
	C406.129364,474.122375 406.269287,473.255737 406.637054,472.145630 
	C406.864929,471.902100 406.929108,471.946198 406.923584,472.337860 
	C406.896637,473.466949 406.875214,474.204346 406.853760,474.941772 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M469.449738,496.532471 
	C469.416382,496.476471 469.483093,496.588440 469.449738,496.532471 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M423.147736,461.240540 
	C423.148956,461.470306 422.854095,461.698944 422.278442,461.961578 
	C422.282288,461.743530 422.566986,461.491455 423.147736,461.240540 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M469.551025,489.467529 
	C469.584412,489.523468 469.517639,489.411560 469.551025,489.467529 
z"/>
<path fill="#58AEE5" opacity="1.000000" stroke="none" 
	d="
M378.512024,382.802368 
	C366.435486,380.976685 356.152557,376.233917 347.309662,368.502869 
	C345.743774,367.133942 344.229279,365.292755 343.645172,363.378510 
	C343.324921,362.329071 344.831177,359.667358 345.809845,359.503815 
	C347.645905,359.196960 350.193512,359.576965 351.575348,360.721527 
	C358.731079,366.648193 366.397308,371.382629 375.681183,373.093262 
	C390.895630,375.896606 404.710236,372.915924 416.902466,363.178711 
	C417.549255,362.662170 418.181885,362.124725 418.789581,361.562958 
	C421.408112,359.142242 424.578400,356.965820 427.297028,360.535004 
	C429.936035,363.999573 426.914337,366.569183 424.283783,368.822021 
	C411.189545,380.036102 396.012848,384.459656 378.512024,382.802368 
z"/>
<path fill="#58AEE5" opacity="1.000000" stroke="none" 
	d="
M356.470154,353.035522 
	C356.277283,351.318329 356.320648,349.735992 356.456421,347.777008 
	C356.548859,347.400391 356.811951,347.269562 357.282104,347.127960 
	C359.154938,346.696350 360.557587,346.406342 361.960236,346.116333 
	C362.285309,346.203156 362.610413,346.289978 363.333191,346.671722 
	C370.324127,354.014282 378.233185,357.542145 388.020081,356.046692 
	C388.760773,356.031494 389.501495,356.016296 390.601501,355.906006 
	C396.374298,353.308868 402.112335,351.319397 407.107056,348.156219 
	C411.803802,345.181702 414.344788,345.612671 415.870483,351.604431 
	C415.885712,351.977478 415.782562,352.275574 415.510773,352.577026 
	C414.788727,353.559296 414.338470,354.240143 413.888184,354.920959 
	C413.888184,354.920959 413.984894,354.979736 413.622314,354.984802 
	C412.378815,355.938385 411.497925,356.886963 410.617035,357.835541 
	C409.521210,358.367584 408.425385,358.899628 406.886719,359.765076 
	C406.173096,360.354919 405.902313,360.611328 405.631531,360.867737 
	C405.631561,360.867737 405.297852,360.850067 404.877625,360.985626 
	C404.189667,361.372070 403.921967,361.622955 403.654297,361.873840 
	C403.654297,361.873840 403.302307,361.873199 402.871643,362.008667 
	C402.152893,362.379181 401.864838,362.614197 401.576813,362.849243 
	C401.576813,362.849243 401.266266,362.814819 400.733276,362.910461 
	C393.138336,363.694550 386.076324,364.382996 379.014343,365.071442 
	C378.578217,365.010620 378.142059,364.949799 377.117828,364.634888 
	C374.345032,363.856110 372.160309,363.331390 369.975616,362.806671 
	C369.975616,362.806671 369.742035,362.701996 369.507904,362.503906 
	C368.836273,362.014374 368.398773,361.722931 367.961273,361.431488 
	C366.556976,360.678436 365.152710,359.925385 363.269531,358.775330 
	C361.549042,357.554047 360.307526,356.729767 359.065979,355.905457 
	C359.065979,355.905457 359.002411,355.956207 358.952728,355.706482 
	C358.616486,355.259857 358.329956,355.063019 358.043396,354.866150 
	C357.597717,354.300873 357.152039,353.735596 356.470154,353.035522 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M379.225464,365.342957 
	C386.076324,364.382996 393.138336,363.694550 400.600281,362.992371 
	C398.169220,364.208130 395.402252,366.245636 392.492035,366.476379 
	C388.197479,366.816864 383.504761,369.549988 379.225464,365.342957 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M370.122314,363.146545 
	C372.160309,363.331390 374.345032,363.856110 376.786774,364.633667 
	C374.785553,364.419830 372.527252,363.953125 370.122314,363.146545 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M359.077637,356.274841 
	C360.307526,356.729767 361.549042,357.554047 362.947388,358.666412 
	C361.765930,358.184387 360.427612,357.414276 359.077637,356.274841 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M410.996094,357.864777 
	C411.497925,356.886963 412.378815,355.938385 413.589294,354.938843 
	C413.070953,355.889923 412.223053,356.891968 410.996094,357.864777 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M414.251099,354.899017 
	C414.338470,354.240143 414.788727,353.559296 415.528748,352.733673 
	C415.417023,353.351624 415.015503,354.114349 414.251099,354.899017 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M368.033997,361.712280 
	C368.398773,361.722931 368.836273,362.014374 369.396057,362.566101 
	C369.047791,362.548584 368.577240,362.270813 368.033997,361.712280 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M401.868774,362.826202 
	C401.864838,362.614197 402.152893,362.379181 402.715820,362.090515 
	C402.714081,362.292297 402.437439,362.547729 401.868774,362.826202 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M403.938904,361.836548 
	C403.921967,361.622955 404.189667,361.372070 404.728729,361.061523 
	C404.741241,361.267670 404.482391,361.533447 403.938904,361.836548 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M405.924591,360.826904 
	C405.902313,360.611328 406.173096,360.354919 406.713593,360.017517 
	C406.728088,360.219757 406.472870,360.502930 405.924591,360.826904 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M358.129303,355.120087 
	C358.329956,355.063019 358.616486,355.259857 358.993408,355.706482 
	C358.794250,355.762207 358.504730,355.568115 358.129303,355.120087 
z"/>
<path fill="#F7FAEB" opacity="1.000000" stroke="none" 
	d="
M222.376678,470.436523 
	C226.317429,473.549377 225.327057,477.400635 223.885742,480.580261 
	C220.769104,487.455750 209.450607,491.050659 202.671738,487.891235 
	C198.806686,486.089813 196.802933,483.195740 196.697601,478.921326 
	C196.593140,474.681976 198.880875,472.114716 202.486099,470.480255 
	C208.948822,467.550293 215.473938,468.584534 222.376678,470.436523 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M236.764923,484.953735 
	C237.164993,484.942505 237.329666,485.212952 237.332642,485.369415 
	C237.066422,488.979736 236.797226,492.433594 236.497498,496.279388 
	C231.871948,492.272339 227.987289,488.907166 224.169403,485.599792 
	C228.777496,481.081055 229.353760,477.846191 225.647400,470.702606 
	C224.371155,468.242767 223.278336,466.669861 226.332794,464.520203 
	C227.589630,463.635712 228.157806,460.571472 227.774582,458.767334 
	C226.182663,451.273254 222.674393,445.011475 214.474289,443.138306 
	C212.852982,442.767944 210.946548,443.886108 209.156311,443.963379 
	C205.716156,444.111908 202.265030,444.006683 198.126190,443.396454 
	C199.814331,442.586548 201.506210,441.081024 203.189957,441.090088 
	C209.639954,441.124756 216.105179,441.453949 222.529678,442.050629 
	C227.107178,442.475708 233.915344,452.650330 233.944382,459.206512 
	C233.977371,466.656647 233.401428,474.109589 233.441299,481.559448 
	C233.447403,482.699799 235.343079,483.830017 236.764923,484.953735 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M201.009399,495.348328 
	C197.631851,493.194489 194.409302,491.508362 191.584915,489.310577 
	C187.079315,485.804443 185.475815,481.301544 188.414993,476.772522 
	C191.298019,472.329956 195.704590,468.838837 199.664322,465.169525 
	C200.315582,464.566040 202.108154,465.194244 204.687515,465.314484 
	C202.110825,466.995850 200.548355,467.968292 199.034821,469.011688 
	C194.254715,472.307068 191.954651,481.064545 194.795074,486.017700 
	C195.641205,487.493225 197.147095,488.839294 198.670181,489.626465 
	C201.930588,491.311462 205.399460,492.593048 208.782959,494.039856 
	C208.691177,494.555389 208.599396,495.070892 208.507629,495.586426 
	C206.119446,495.586426 203.731262,495.586426 201.009399,495.348328 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M219.960388,449.608765 
	C213.208984,448.315643 206.477478,448.619293 199.869675,451.438263 
	C198.583084,451.987122 196.972733,451.777069 195.068481,451.841370 
	C202.676666,445.813782 212.657379,444.822357 219.960388,449.608765 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M219.273438,462.265137 
	C221.238724,460.304352 223.159012,458.725464 220.599472,455.622833 
	C219.834763,454.695862 220.263748,452.784180 220.250061,450.878906 
	C225.038071,453.400146 224.783829,457.961090 224.673874,463.253296 
	C222.655319,462.976044 221.100662,462.762482 219.273438,462.265137 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M193.608826,451.984161 
	C193.464462,453.313416 192.945587,454.631073 192.346237,456.153107 
	C185.723114,453.967407 186.965820,449.517212 188.444977,445.031433 
	C190.246353,447.304565 191.740311,449.638580 193.608826,451.984161 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M193.484894,465.095215 
	C193.693787,459.571136 199.215897,462.409149 201.824509,460.140106 
	C202.466202,459.581970 204.283447,460.375305 205.798752,460.861816 
	C201.976685,462.467682 197.916138,463.759094 193.484894,465.095215 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M188.432281,469.035339 
	C187.362534,465.589264 189.180435,464.659882 192.696991,465.069946 
	C191.662109,466.393890 190.203918,467.669678 188.432281,469.035339 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M213.249969,461.310669 
	C214.277771,461.067657 215.579727,461.049530 216.973602,461.345276 
	C215.885056,461.617950 214.704590,461.576752 213.249969,461.310669 
z"/>
<path fill="#7EA821" opacity="1.000000" stroke="none" 
	d="
M283.933441,166.513397 
	C289.347839,159.322235 285.929962,149.229294 277.951385,146.768372 
	C274.221527,145.617905 270.809204,143.456940 267.213623,141.841446 
	C266.062103,141.324081 264.788147,140.792831 263.563721,140.777237 
	C259.746155,140.728577 255.890945,141.271667 252.118744,140.896851 
	C249.769180,140.663422 246.178345,139.709045 245.577896,138.144394 
	C244.648560,135.722733 244.785080,131.577408 246.341858,129.872040 
	C248.025986,128.027130 252.665619,126.635300 254.610077,127.675163 
	C261.703247,131.468475 267.180450,133.416122 275.129242,127.658005 
	C281.345642,123.154816 290.450500,123.914009 298.643005,125.808151 
	C304.044403,127.056992 308.977386,128.411514 313.046906,132.587555 
	C313.987213,133.552429 318.021057,133.041931 319.327789,131.818283 
	C323.064850,128.318771 326.835388,127.830360 331.621979,128.944016 
	C335.558105,129.859772 336.918579,132.476151 336.679993,135.591431 
	C336.573242,136.985565 333.902252,139.033142 332.167053,139.299454 
	C326.028534,140.241547 319.791626,140.542358 313.344147,141.107986 
	C313.611816,146.299194 308.084198,143.988434 305.056244,144.795837 
	C299.715973,146.219803 297.470947,148.914413 297.011383,156.922440 
	C296.648224,163.250900 298.253967,165.448700 303.859222,167.005310 
	C306.088654,167.624435 308.155365,168.829681 311.252716,170.187408 
	C305.204315,172.444351 300.731995,174.144852 296.226807,175.753326 
	C295.678436,175.949112 294.945007,175.694077 294.311584,175.573257 
	C289.930481,174.737671 285.517242,174.030273 281.187622,172.979645 
	C278.438171,172.312469 275.814850,171.125580 273.134979,170.171768 
	C273.278229,169.705994 273.421509,169.240219 273.564758,168.774445 
	C276.911560,168.086044 280.258331,167.397644 283.933441,166.513397 
z"/>
<path fill="#7BA51D" opacity="1.000000" stroke="none" 
	d="
M360.426575,250.762894 
	C359.877045,249.538940 359.528534,247.414795 358.744812,247.239792 
	C354.270966,246.240799 349.711548,245.333603 345.146393,245.111847 
	C339.953827,244.859634 334.724701,245.360596 328.889862,245.802368 
	C326.883942,247.071304 325.539429,248.133484 324.108002,249.061523 
	C319.202911,252.241638 323.427521,260.847870 316.066833,262.542908 
	C314.908630,268.077271 309.881317,270.184967 305.813934,271.737946 
	C301.427032,273.412933 296.061798,272.980011 291.187256,272.614563 
	C289.915314,272.519196 288.881042,269.254211 287.671753,267.340698 
	C280.210876,267.903503 279.552277,267.377655 277.979706,259.635681 
	C277.142914,255.516098 274.045227,253.546753 270.369873,253.146500 
	C265.937286,252.663773 261.294250,252.408218 256.966736,253.232559 
	C253.789703,253.837753 250.973801,256.338928 247.996948,257.995117 
	C247.401321,258.255371 246.828522,258.612549 246.206116,258.759033 
	C243.590958,259.374542 240.960968,259.927032 238.336411,260.502594 
	C237.875854,258.325989 237.047241,256.154419 237.017456,253.971909 
	C236.876831,243.662872 236.954742,233.350830 236.954742,223.912186 
	C239.312790,222.675262 241.077606,221.749512 243.259674,220.604904 
	C249.864090,225.213181 257.988159,222.446762 265.730133,222.627350 
	C267.109497,222.659531 269.448425,219.822983 269.801575,218.010498 
	C270.668427,213.561417 270.847168,208.939041 270.890137,204.382477 
	C270.918823,201.341980 271.533661,199.907837 275.015717,199.879990 
	C283.468079,199.812439 291.916870,199.303665 300.367310,198.978455 
	C306.671478,198.735825 308.093414,200.026154 307.989746,206.341934 
	C307.927429,210.139038 307.294281,213.940216 307.434326,217.720428 
	C307.488403,219.179398 308.642883,221.166550 309.886292,221.870773 
	C311.497894,222.783524 313.697662,222.919159 315.647156,222.931488 
	C328.301483,223.011459 340.963287,222.720352 353.608643,223.064804 
	C360.187927,223.244034 367.020905,223.557388 373.227356,225.470718 
	C380.234955,227.631027 387.638397,230.194138 391.065186,238.093704 
	C391.883240,239.979584 394.012543,241.296661 395.914551,242.894226 
	C396.290314,242.913086 396.523102,243.345581 396.171997,243.768463 
	C395.711151,245.747879 395.356598,247.334808 395.545349,248.854279 
	C395.885315,251.591354 396.550690,254.288040 396.791687,257.232605 
	C396.677368,259.889252 396.551819,262.391663 397.145782,264.709686 
	C397.466309,265.960510 399.017700,266.895935 400.013733,267.973663 
	C400.026154,273.387512 400.038574,278.801361 399.581055,284.619415 
	C396.016846,285.304230 392.874329,286.064728 389.838898,285.759735 
	C384.482269,285.221497 378.492310,287.876282 373.899170,282.969513 
	C373.905914,282.528931 373.912689,282.088348 374.152710,281.186951 
	C374.241669,280.152802 374.097321,279.579468 373.952972,279.006165 
	C374.914398,270.626465 372.210236,263.150665 367.978882,256.176941 
	C366.964172,254.504532 364.913483,253.460709 362.960083,252.192322 
	C362.004089,251.947464 361.427246,251.638107 360.586365,251.093506 
	C360.322357,250.858261 360.426575,250.762894 360.426575,250.762894 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M248.122803,258.229858 
	C250.973801,256.338928 253.789703,253.837753 256.966736,253.232559 
	C261.294250,252.408218 265.937286,252.663773 270.369873,253.146500 
	C274.045227,253.546753 277.142914,255.516098 277.979706,259.635681 
	C279.552277,267.377655 280.210876,267.903503 287.671753,267.340698 
	C288.881042,269.254211 289.915314,272.519196 291.187256,272.614563 
	C296.061798,272.980011 301.427032,273.412933 305.813934,271.737946 
	C309.881317,270.184967 314.908630,268.077271 316.066833,262.542908 
	C323.427521,260.847870 319.202911,252.241638 324.108002,249.061523 
	C325.539429,248.133484 326.883942,247.071304 328.642120,246.097244 
	C329.020569,246.594925 329.025208,247.065964 329.050720,247.892441 
	C327.751740,250.377380 325.865112,252.344559 325.201477,254.661972 
	C319.810669,273.486359 300.953644,281.669312 283.721252,272.460449 
	C277.886017,269.342133 274.056641,264.903290 274.835327,256.940948 
	C266.212860,257.572632 257.886597,255.301178 249.431870,258.830811 
	C248.831848,258.856415 248.540237,258.660492 248.122803,258.229858 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M312.569305,191.891815 
	C311.900848,192.518188 310.792358,193.068375 309.442841,193.738190 
	C309.904755,194.592270 310.400177,195.508286 310.918457,196.758636 
	C297.269958,196.977921 283.598602,196.862869 269.468994,196.649368 
	C270.572083,196.035599 272.126740,195.099136 273.695801,195.074387 
	C282.752472,194.931625 291.814484,195.096771 300.869385,194.905655 
	C302.251221,194.876495 303.605377,193.536560 304.987030,192.383850 
	C307.377563,191.915085 309.753418,191.865356 312.569305,191.891815 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M310.916565,197.463959 
	C314.534454,198.705872 313.061615,201.303177 311.778656,204.006302 
	C311.240997,202.102936 311.083130,199.988068 310.916565,197.463959 
z"/>
<path fill="#F4FBFC" opacity="1.000000" stroke="none" 
	d="
M490.727295,451.616760 
	C501.934967,443.919525 512.059570,451.169128 515.852844,458.390045 
	C520.644287,467.511078 517.671631,481.437439 507.642181,485.891754 
	C499.707306,489.415741 489.002502,485.144958 485.307983,476.474365 
	C482.352600,469.538544 484.923187,457.122223 490.727295,451.616760 
z"/>
<path fill="#52AAE8" opacity="1.000000" stroke="none" 
	d="
M486.461853,488.860199 
	C485.567871,488.441864 485.009766,488.029358 484.451691,487.616852 
	C483.643127,489.314270 482.201965,490.987701 482.136627,492.713257 
	C481.867889,499.809937 482.164642,506.928070 481.891907,514.024475 
	C481.835815,515.484131 480.552338,517.424988 479.266113,518.197266 
	C476.726776,519.722046 474.427307,519.395752 473.957825,515.683960 
	C473.846283,514.801941 473.235474,513.983093 472.499634,513.039551 
	C472.103027,506.621613 472.061096,500.299377 472.459045,493.404449 
	C474.210083,489.089966 475.569366,485.344727 472.119751,481.943604 
	C472.085266,473.620850 472.050812,465.298126 472.425354,456.427063 
	C474.613983,453.953247 474.932556,452.232452 472.143311,450.947144 
	C472.257843,447.147430 472.372375,443.347717 473.175354,439.388794 
	C476.232452,439.809296 478.601135,440.388977 480.984406,440.983521 
	C480.999023,440.998383 481.028992,441.027649 481.028992,441.027649 
	C481.017944,442.023010 480.717621,443.133270 481.057648,443.989197 
	C481.712646,445.638092 482.426086,448.012177 483.685974,448.452393 
	C484.842499,448.856506 486.799469,447.194153 488.309387,446.285339 
	C489.356567,445.655060 490.243591,444.758667 491.762512,444.225372 
	C493.220978,444.992279 494.119141,445.514954 495.017334,446.037659 
	C491.923828,448.285767 488.625183,450.309814 485.822784,452.875793 
	C484.409912,454.169525 483.157043,456.426971 483.110107,458.281036 
	C482.944397,464.826965 482.726379,471.484802 483.765076,477.899902 
	C484.279602,481.077606 487.492615,483.818329 489.790466,487.207764 
	C488.892822,487.705139 487.845306,488.285583 486.461853,488.860199 
z"/>
<path fill="#47ADF0" opacity="1.000000" stroke="none" 
	d="
M495.404694,445.980347 
	C494.119141,445.514954 493.220978,444.992279 492.129700,444.208405 
	C493.336090,443.226562 494.660553,442.218109 496.146912,441.830322 
	C509.118439,438.446198 515.471863,441.969727 523.394165,452.420868 
	C529.766113,460.826904 529.355164,469.149292 526.798584,477.809326 
	C525.535217,482.088837 522.535034,486.594940 519.022217,489.332062 
	C508.581940,497.466858 508.330200,497.143768 491.263733,489.990814 
	C492.822693,489.810364 494.378296,489.590576 495.941254,489.456970 
	C500.331879,489.081665 504.873108,489.322998 509.083740,488.253387 
	C515.594360,486.599518 519.033081,481.325562 519.610291,475.078003 
	C520.167664,469.045776 520.351501,462.521637 518.560364,456.894470 
	C517.412354,453.287598 512.799744,450.058319 508.987457,448.226135 
	C505.084656,446.350464 500.732941,443.361420 495.404694,445.980347 
z"/>
<path fill="#52AAE8" opacity="1.000000" stroke="none" 
	d="
M481.079224,438.983765 
	C481.470062,439.423737 481.860931,439.863678 482.239014,440.614197 
	C482.026306,440.938049 481.826355,440.951294 481.327698,440.996094 
	C481.028992,441.027649 480.999023,440.998383 481.011353,440.653381 
	C481.042206,439.866821 481.060730,439.425293 481.079224,438.983765 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M169.755417,432.969849 
	C170.482025,433.401276 170.819427,433.849854 171.208069,434.583740 
	C170.351791,436.532043 169.444275,438.195068 168.338943,440.220581 
	C173.154953,441.974945 174.252136,445.631439 172.670456,450.595734 
	C170.501709,450.611176 168.753296,450.306213 166.950531,449.613403 
	C166.675461,448.598114 166.381805,447.986084 166.244843,447.340790 
	C163.581726,434.792908 153.788315,427.030121 140.680496,426.992920 
	C136.866913,426.982117 132.951569,427.227600 129.264648,426.470459 
	C123.621696,425.311615 121.141418,426.827576 121.041428,432.683197 
	C120.953224,437.848297 121.120171,443.018219 121.008736,448.182434 
	C120.761543,459.638702 120.182373,471.095428 120.320763,482.544952 
	C120.344482,484.507599 122.940468,486.945496 124.953888,488.158539 
	C125.922653,488.742279 128.301804,486.985107 130.492050,486.198547 
	C134.622925,486.130402 138.304031,486.151703 142.066956,486.526184 
	C143.762833,487.243927 145.376862,487.608429 146.828644,488.233978 
	C146.778458,489.997894 146.890533,491.500793 147.002609,493.003662 
	C145.540619,493.665253 144.088501,494.873230 142.615051,494.899780 
	C133.040100,495.072540 123.460533,494.988434 113.422920,494.988434 
	C113.263908,493.241150 113.022865,491.814575 113.020943,490.387695 
	C112.992638,469.420410 112.978958,448.453094 113.002907,427.485809 
	C113.009857,421.407074 113.471161,421.001282 119.563553,420.988434 
	C125.554192,420.975830 131.630173,421.616486 137.514572,420.824768 
	C145.403931,419.763336 152.094925,423.200684 159.073318,425.395599 
	C161.606552,426.192444 163.353897,429.324219 165.626068,431.187897 
	C166.665405,432.040436 168.107040,432.402496 169.755417,432.969849 
z"/>
<path fill="#7BA51D" opacity="1.000000" stroke="none" 
	d="
M147.404236,493.003448 
	C146.890533,491.500793 146.778458,489.997894 147.011597,487.902588 
	C148.676208,486.862946 149.995224,486.041840 151.315140,486.040375 
	C154.927841,486.036438 157.114990,484.449127 158.392715,480.999084 
	C160.159424,479.640228 161.562592,478.286133 162.963882,476.571594 
	C163.296967,475.136627 163.631927,474.062134 164.323456,472.934326 
	C165.876602,471.206543 167.073151,469.532074 168.269684,467.857605 
	C168.709457,467.960052 169.149231,468.062469 169.588989,468.164886 
	C169.727005,470.449249 169.865036,472.733612 170.003052,475.017975 
	C169.677109,475.788849 169.351196,476.559723 168.692413,477.707855 
	C167.918854,478.745819 167.478165,479.406555 167.037445,480.067261 
	C161.884842,486.249359 156.723083,492.417877 147.404236,493.003448 
z"/>
<path fill="#7BA51D" opacity="1.000000" stroke="none" 
	d="
M167.004883,450.001221 
	C168.753296,450.306213 170.501709,450.611176 172.630646,450.957703 
	C173.021744,452.707245 173.032333,454.415253 172.754227,456.790161 
	C171.793335,460.295502 171.121155,463.133911 170.478378,465.848114 
	C169.450531,465.597809 168.208084,465.295258 166.973389,464.527344 
	C166.989044,459.375092 166.996964,454.688141 167.004883,450.001221 
z"/>
<path fill="#F7FAEB" opacity="1.000000" stroke="none" 
	d="
M178.293457,470.848999 
	C177.914398,469.029663 177.860519,467.078033 177.485123,465.052124 
	C177.161407,464.237488 177.159195,463.497162 177.591339,462.272430 
	C177.833862,458.844147 177.642029,455.900269 177.450195,452.956360 
	C177.239090,451.259949 177.027969,449.563538 176.853882,447.439423 
	C180.420822,446.808075 180.856277,449.236176 180.987549,451.874390 
	C181.232376,456.795166 181.676285,461.725067 181.519470,466.634613 
	C181.475052,468.024780 179.635101,469.357574 178.293457,470.848999 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M166.965637,464.992706 
	C168.208084,465.295258 169.450531,465.597809 170.478378,465.848114 
	C171.121155,463.133911 171.793335,460.295502 172.757080,457.216980 
	C172.702271,462.997253 174.719650,469.320923 170.377502,474.947327 
	C169.865036,472.733612 169.727005,470.449249 169.588989,468.164886 
	C169.149231,468.062469 168.709457,467.960052 168.269684,467.857605 
	C167.073151,469.532074 165.876602,471.206543 164.368073,472.563538 
	C165.025925,469.828308 165.995773,467.410492 166.965637,464.992706 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M177.361389,453.402710 
	C177.642029,455.900269 177.833862,458.844147 177.674164,461.910889 
	C177.305954,459.305481 177.289261,456.577271 177.361389,453.402710 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M167.356293,480.009460 
	C167.478165,479.406555 167.918854,478.745819 168.686356,478.043091 
	C168.567154,478.651306 168.121155,479.301483 167.356293,480.009460 
z"/>
<path fill="#49ABED" opacity="1.000000" stroke="none" 
	d="
M377.991333,430.998108 
	C375.214447,429.669739 372.540833,427.579224 369.637268,427.185913 
	C364.906830,426.545105 359.993408,427.334290 355.225800,426.847717 
	C353.425598,426.664001 350.610046,424.809418 350.374908,423.370422 
	C349.909302,420.521606 352.473511,419.974426 355.119263,419.919586 
	C363.979279,419.735962 372.834564,419.078430 381.691772,419.076080 
	C390.203400,419.073822 398.726929,419.505463 407.214569,420.150360 
	C408.539398,420.251007 409.700806,422.502197 410.937805,423.758972 
	C409.616241,424.840759 408.352936,426.759003 406.962738,426.855804 
	C401.672791,427.224213 396.337982,426.877258 391.027405,427.040100 
	C385.639648,427.205353 384.260956,428.767578 384.648682,433.595825 
	C382.193115,432.951050 380.092224,431.974579 377.991333,430.998108 
z"/>
<path fill="#47ADF0" opacity="1.000000" stroke="none" 
	d="
M377.686218,431.235413 
	C380.092224,431.974579 382.193115,432.951050 384.647034,433.964355 
	C385.005066,450.021179 385.010101,466.041168 384.644928,482.598663 
	C383.842102,484.100952 383.262970,485.028015 383.003601,486.037292 
	C382.123749,489.461182 380.362549,490.879059 376.942383,488.979095 
	C376.629089,472.038330 376.260925,455.098175 376.068970,438.156036 
	C376.043793,435.933502 376.921509,433.700714 377.686218,431.235413 
z"/>
<path fill="#49ABED" opacity="1.000000" stroke="none" 
	d="
M376.680023,489.228333 
	C380.362549,490.879059 382.123749,489.461182 383.003601,486.037292 
	C383.262970,485.028015 383.842102,484.100952 384.638550,483.067169 
	C385.002441,486.428558 385.002441,489.859009 385.002441,493.131958 
	C376.523621,495.511536 376.211151,495.364532 376.680023,489.228333 
z"/>
<path fill="#58AEE5" opacity="1.000000" stroke="none" 
	d="
M385.060883,305.690063 
	C385.444672,305.308960 385.783966,305.268036 386.378845,305.232300 
	C388.899719,310.390930 391.443146,315.444153 393.346558,320.727905 
	C395.009552,325.344391 393.056641,329.502838 389.167328,331.127441 
	C385.740112,332.558990 381.902100,332.429230 380.254059,329.226379 
	C378.769073,326.340332 378.220306,322.215576 379.021973,319.089325 
	C380.192627,314.524109 382.940704,310.363403 385.060883,305.690063 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M272.563538,191.893555 
	C271.035004,196.308365 268.545593,192.041122 266.118591,192.051987 
	C267.976379,191.762863 270.051880,191.792587 272.563538,191.893555 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M328.906403,489.254761 
	C328.500580,489.240326 328.094727,489.225861 327.390930,489.278687 
	C326.829773,487.327179 326.566650,485.308380 326.081055,482.815491 
	C326.120605,481.829346 326.382629,481.317322 326.644623,480.805298 
	C330.990112,480.000671 330.268005,476.422943 329.810272,473.810333 
	C329.448639,471.746216 327.918884,469.151123 326.159271,468.244171 
	C323.670715,466.961456 320.492645,467.016449 317.509247,465.726532 
	C320.633575,465.126312 323.757874,464.526093 327.048950,463.571777 
	C332.265350,458.402466 329.705170,448.801300 322.266052,445.774078 
	C315.347900,442.958862 308.324005,444.010986 301.483551,446.450623 
	C300.868042,446.670074 300.545197,447.710236 300.054382,448.750793 
	C300.022339,449.132355 299.787811,449.312469 299.642517,449.326660 
	C298.178528,448.819397 296.859833,448.297974 294.663513,447.429474 
	C298.510803,444.516998 301.713287,442.092621 305.057434,439.117554 
	C305.199066,438.566864 305.337555,438.118561 305.337555,438.118561 
	C305.985168,438.180420 306.632812,438.242310 307.643433,438.766571 
	C312.524994,442.573914 317.270691,441.206665 322.245850,439.817474 
	C322.780060,439.542816 322.959747,439.273590 323.017456,438.922913 
	C323.574280,439.049866 324.131104,439.176819 324.980469,439.829346 
	C327.837036,443.012604 330.318054,445.758545 333.003448,448.287415 
	C334.179657,449.395172 335.773285,450.059601 337.177368,450.925323 
	C337.177368,450.925323 337.358673,451.203308 337.253876,451.866974 
	C337.795319,460.688599 338.441559,468.846588 339.087769,477.004547 
	C339.122803,478.062073 339.157806,479.119568 338.862732,480.805237 
	C338.738281,483.477356 339.062744,485.518005 339.120697,487.566162 
	C339.200989,490.403870 339.080933,493.247253 338.684753,496.056061 
	C336.194550,494.391815 334.066254,492.759705 331.928589,491.105591 
	C331.919250,491.083527 331.886108,491.049377 331.889526,490.711945 
	C330.897461,490.001282 329.901947,489.628021 328.906403,489.254761 
z"/>
<path fill="#F7FAEB" opacity="1.000000" stroke="none" 
	d="
M326.672119,480.374451 
	C326.382629,481.317322 326.120605,481.829346 325.779358,482.635681 
	C319.483887,488.489716 312.427979,490.414368 303.800842,487.445099 
	C299.661591,483.857391 298.624817,479.847809 299.531616,474.993164 
	C299.671021,474.553284 299.678314,474.364380 299.685577,474.175476 
	C306.787872,467.330414 315.203857,467.925079 323.718323,470.287750 
	C325.046814,470.656403 326.238495,472.926605 326.719849,474.547333 
	C327.210266,476.198425 326.745911,478.133087 326.672119,480.374451 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M299.380249,474.057495 
	C299.678314,474.364380 299.671021,474.553284 299.115845,474.961304 
	C298.040710,476.710938 296.753723,478.476257 297.139465,479.724701 
	C298.026581,482.595856 299.727631,485.215546 301.098389,487.937286 
	C307.065186,493.254669 313.615540,490.848145 320.060608,489.785950 
	C319.922546,491.417542 315.190582,495.379425 312.218048,495.968140 
	C303.757477,497.643768 292.519287,490.963684 290.099121,482.820465 
	C289.035461,479.241577 293.121002,470.306732 296.618347,468.758484 
	C297.285187,468.463196 298.354065,468.322601 298.872711,468.664276 
	C299.362457,468.986877 299.552765,470.039459 299.549561,470.769531 
	C299.544891,471.826874 299.247437,472.882935 299.380249,474.057495 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M301.520386,487.931519 
	C299.727631,485.215546 298.026581,482.595856 297.139465,479.724701 
	C296.753723,478.476257 298.040710,476.710938 298.983765,475.212280 
	C298.624817,479.847809 299.661591,483.857391 303.439148,487.336395 
	C303.057495,487.739838 302.499939,487.832794 301.520386,487.931519 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M310.216064,466.788208 
	C307.362244,466.910919 304.895050,466.910919 302.427826,466.910919 
	C302.435699,466.458008 302.443604,466.005127 302.451477,465.552216 
	C305.721161,464.985748 308.990814,464.419312 312.260498,463.852844 
	C312.392883,464.245575 312.525269,464.638306 312.657623,465.031006 
	C311.972626,465.575836 311.287628,466.120667 310.216064,466.788208 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M252.329865,438.724365 
	C256.761658,437.401093 254.974289,433.609863 255.846085,430.991669 
	C256.502838,429.019226 255.944901,426.609772 256.719818,424.719574 
	C257.327393,423.237549 259.147919,422.252808 260.429565,421.047150 
	C261.627777,422.585114 263.495453,423.977142 263.869873,425.694702 
	C264.455475,428.381012 263.991547,431.288330 264.042358,434.100769 
	C264.136475,439.308746 265.693787,440.654297 270.872864,441.047638 
	C272.966125,441.206635 276.121643,439.220428 276.643585,443.625214 
	C275.182739,445.283142 274.062256,446.497894 272.941772,447.712646 
	C272.521088,447.771667 272.100372,447.830658 271.353333,447.464844 
	C270.454041,446.416473 269.881042,445.792969 269.308075,445.169434 
	C268.862762,445.759583 268.417480,446.349731 267.951721,447.162964 
	C267.931213,447.386017 267.928375,447.834015 267.928375,447.834015 
	C267.519073,447.970093 267.109741,448.106140 266.412262,448.206116 
	C266.124084,448.169983 266.053467,447.843414 266.040344,447.552551 
	C265.895813,446.780151 265.764465,446.298645 265.633087,445.817108 
	C265.437225,445.841766 265.241364,445.866394 265.045502,445.891052 
	C265.045502,446.609222 265.045502,447.327423 265.027588,448.278442 
	C265.009674,448.511261 264.968628,448.976471 264.584198,449.070435 
	C264.157043,452.448456 264.114319,455.732513 264.056213,459.443176 
	C264.048981,461.581573 264.057098,463.293335 263.755646,465.285950 
	C263.305267,469.919342 263.067657,474.272827 263.111176,478.623505 
	C263.119171,479.425262 264.265442,480.215668 264.995117,481.228210 
	C265.273621,481.739746 265.520721,481.937805 265.845154,482.039337 
	C266.026581,482.611664 266.208038,483.184021 266.424194,484.046753 
	C265.494995,487.605957 266.789215,489.056641 270.117889,488.979095 
	C271.748871,488.941132 273.383026,489.064606 275.016144,489.086517 
	C276.566895,489.107361 278.118134,489.091003 280.076538,489.091003 
	C279.741730,490.548798 279.758575,491.587952 279.437225,491.705902 
	C275.318542,493.217926 271.170319,495.589600 266.990234,495.668915 
	C264.127380,495.723206 259.408997,493.093719 258.666687,490.691620 
	C256.935822,485.090271 256.877991,478.914124 256.558502,472.948547 
	C256.126984,464.891205 256.434692,456.774994 255.564590,448.777679 
	C255.402390,447.286926 251.183273,446.237579 248.409470,444.643982 
	C248.322296,442.521210 248.662094,440.738983 249.001877,438.956726 
	C249.988190,438.884827 250.974503,438.812927 252.329865,438.724365 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M264.886322,481.011292 
	C264.265442,480.215668 263.119171,479.425262 263.111176,478.623505 
	C263.067657,474.272827 263.305267,469.919342 264.028381,465.564270 
	C264.999298,468.368042 265.387878,471.174347 265.776428,473.980652 
	C265.815765,476.017059 265.855103,478.053467 265.617798,480.532166 
	C265.341187,480.974426 264.886322,481.011292 264.886322,481.011292 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M264.071564,459.016571 
	C264.114319,455.732513 264.157043,452.448456 264.599060,449.498413 
	C265.265137,452.216858 265.531952,454.601349 265.798767,456.985809 
	C265.825378,457.422241 265.851959,457.858673 265.541046,458.633545 
	C264.826233,458.986847 264.448883,459.001709 264.071564,459.016571 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M264.056213,459.443176 
	C264.448883,459.001709 264.826233,458.986847 265.486816,458.957794 
	C265.836090,463.651917 265.902130,468.360260 265.872314,473.524628 
	C265.387878,471.174347 264.999298,468.368042 264.337952,465.283417 
	C264.057098,463.293335 264.048981,461.581573 264.056213,459.443176 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M273.305237,447.835846 
	C274.062256,446.497894 275.182739,445.283142 276.654938,444.038452 
	C276.688568,445.057068 276.370453,446.105621 275.997314,447.479065 
	C275.184418,447.855713 274.426544,447.907379 273.305237,447.835846 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M265.891663,456.558533 
	C265.531952,454.601349 265.265137,452.216858 264.983459,449.404419 
	C264.968628,448.976471 265.009674,448.511261 265.282837,448.245178 
	C265.721802,447.933868 265.887634,447.888641 266.053467,447.843414 
	C266.053467,447.843414 266.124084,448.169983 266.116760,448.338196 
	C266.067810,451.048065 266.026215,453.589661 265.891663,456.558533 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M267.972198,446.939880 
	C268.417480,446.349731 268.862762,445.759583 269.308075,445.169434 
	C269.881042,445.792969 270.454041,446.416473 271.042419,447.380005 
	C270.606689,447.824280 270.155548,447.928558 269.238373,447.772583 
	C268.552521,447.256012 268.285797,447.065216 267.972198,446.939880 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M267.951721,447.162964 
	C268.285797,447.065216 268.552521,447.256012 268.891174,447.729004 
	C268.824921,447.974640 268.639862,448.003479 268.191589,447.933167 
	C267.928375,447.834015 267.931213,447.386017 267.951721,447.162964 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M264.995117,481.228210 
	C264.886322,481.011292 265.341187,480.974426 265.568909,480.965973 
	C265.854218,481.135498 265.911835,481.313477 265.907318,481.765411 
	C265.520721,481.937805 265.273621,481.739746 264.995117,481.228210 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M248.582047,438.882141 
	C248.662094,440.738983 248.322296,442.521210 248.021667,444.617615 
	C248.048218,445.664246 248.035599,446.396637 248.025360,447.492981 
	C244.809586,445.458008 244.870819,441.338043 248.582047,438.882141 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M339.046631,496.088226 
	C339.080933,493.247253 339.200989,490.403870 339.120697,487.566162 
	C339.062744,485.518005 338.738281,483.477356 338.831848,481.201233 
	C340.346008,485.247589 341.773041,489.485352 342.608826,493.836700 
	C342.790375,494.781860 340.852112,496.134186 339.465332,496.985291 
	C339.042572,496.477142 339.044617,496.282684 339.046631,496.088226 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M337.181274,450.559143 
	C335.773285,450.059601 334.179657,449.395172 333.003448,448.287415 
	C330.318054,445.758545 327.837036,443.012604 325.211090,440.002228 
	C331.097443,440.953644 335.047943,444.538269 337.181274,450.559143 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M322.013275,439.904327 
	C317.270691,441.206665 312.524994,442.573914 307.957031,438.852875 
	C312.385559,438.435394 316.863556,438.394012 321.693909,438.820740 
	C322.035278,439.494019 322.024292,439.699158 322.013275,439.904327 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M339.185913,476.542969 
	C338.441559,468.846588 337.795319,460.688599 337.257233,452.032898 
	C338.018707,456.557892 338.820648,461.567383 339.270813,466.608307 
	C339.550659,469.741394 339.297791,472.922089 339.185913,476.542969 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M338.684753,496.056061 
	C339.044617,496.282684 339.042572,496.477142 339.048950,496.964355 
	C338.691956,497.300385 338.326477,497.343628 337.261078,497.241302 
	C336.269867,497.113098 335.978607,497.130493 335.687347,497.147888 
	C334.590027,496.945007 333.492706,496.742157 332.199463,495.857605 
	C331.981659,493.826477 331.959808,492.477051 331.937958,491.127625 
	C334.066254,492.759705 336.194550,494.391815 338.684753,496.056061 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M331.928589,491.105591 
	C331.959808,492.477051 331.981659,493.826477 332.000519,495.583771 
	C331.607605,495.891449 331.217712,495.791260 330.568176,495.529907 
	C329.901062,494.129883 329.493561,492.890930 329.466583,491.326111 
	C330.526764,491.016571 331.206451,491.032959 331.886108,491.049377 
	C331.886108,491.049377 331.919250,491.083527 331.928589,491.105591 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M322.245850,439.817474 
	C322.024292,439.699158 322.035278,439.494019 322.080688,438.980713 
	C322.115051,438.672546 322.599762,438.675751 322.808594,438.799316 
	C322.959747,439.273590 322.780060,439.542816 322.245850,439.817474 
z"/>
<path fill="#ECF6D5" opacity="1.000000" stroke="none" 
	d="
M305.087677,438.137146 
	C305.337555,438.118561 305.199066,438.566864 305.105591,438.781921 
	C305.012115,438.996979 304.525543,438.886139 304.287598,438.811218 
	C304.235229,438.438110 304.497955,438.244598 305.087677,438.137146 
z"/>
<path fill="#93A95D" opacity="1.000000" stroke="none" 
	d="
M335.872467,497.317627 
	C335.978607,497.130493 336.269867,497.113098 336.998169,497.148804 
	C336.976013,497.297058 336.516785,497.392212 335.872467,497.317627 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M387.779846,355.750305 
	C378.233185,357.542145 370.324127,354.014282 363.586060,346.655212 
	C367.415558,344.505219 368.969391,348.202850 371.112610,349.984558 
	C375.947479,354.003998 382.107849,353.536804 387.779846,355.750305 
z"/>
<path fill="#D9F6FD" opacity="1.000000" stroke="none" 
	d="
M361.946350,345.758514 
	C360.557587,346.406342 359.154938,346.696350 357.394501,347.033325 
	C357.788788,345.865936 358.540863,344.651581 359.292938,343.437225 
	C360.172791,344.091705 361.052612,344.746185 361.946350,345.758514 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M489.989136,435.243225 
	C490.099335,435.409668 490.045288,435.577606 489.991241,435.745544 
	C489.935822,435.578613 489.880371,435.411682 489.989136,435.243225 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M373.575562,283.031982 
	C378.492310,287.876282 384.482269,285.221497 389.838898,285.759735 
	C392.874329,286.064728 396.016846,285.304230 399.567078,285.040558 
	C398.757324,286.038116 397.528656,287.804016 396.219482,287.865875 
	C389.937683,288.162567 383.628357,288.155518 377.341003,287.924438 
	C374.648285,287.825470 371.785492,287.086151 373.575562,283.031982 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M400.013885,267.575012 
	C399.017700,266.895935 397.466309,265.960510 397.145782,264.709686 
	C396.551819,262.391663 396.677368,259.889252 397.113373,257.279358 
	C398.737579,258.068237 399.751678,259.041351 400.765778,260.014465 
	C400.849976,260.458313 400.934174,260.902191 400.980133,261.684387 
	C400.632599,263.740601 400.323303,265.458496 400.013885,267.575012 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M370.449524,270.658936 
	C369.912170,269.176514 369.480469,267.345978 369.088593,265.098114 
	C369.604004,266.557465 370.079620,268.434143 370.449524,270.658936 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M373.734863,279.149384 
	C374.097321,279.579468 374.241669,280.152802 374.141418,280.856628 
	C373.770081,280.422272 373.643402,279.857452 373.734863,279.149384 
z"/>
<path fill="#EAF4D1" opacity="1.000000" stroke="none" 
	d="
M369.025665,263.679810 
	C368.697571,263.456421 368.386414,262.905975 368.103577,262.017120 
	C368.435486,262.236725 368.739044,262.794708 369.025665,263.679810 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M400.832855,259.614136 
	C399.751678,259.041351 398.737579,258.068237 397.401794,257.048340 
	C396.550690,254.288040 395.885315,251.591354 395.545349,248.854279 
	C395.356598,247.334808 395.711151,245.747879 396.205505,244.011749 
	C398.026764,248.959366 399.463348,254.086578 400.832855,259.614136 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M303.590607,450.518372 
	C304.062561,450.574951 304.349640,450.808105 304.636719,451.041260 
	C304.447357,451.222473 304.257996,451.403656 304.068604,451.584839 
	C303.847656,451.288208 303.626678,450.991547 303.590607,450.518372 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M360.424255,250.816086 
	C360.426575,250.762894 360.322357,250.858261 360.296967,250.925476 
	C360.271576,250.992706 360.317352,251.003464 360.339233,251.006897 
	C360.361084,251.010345 360.421936,250.869278 360.424255,250.816086 
z"/>
<path fill="#88A345" opacity="1.000000" stroke="none" 
	d="
M331.889526,490.711914 
	C331.206451,491.032959 330.526764,491.016571 329.506409,490.991058 
	C329.078735,490.601471 328.991821,490.221039 328.905640,489.547668 
	C329.901947,489.628021 330.897461,490.001282 331.889526,490.711914 
z"/>
<path fill="#47ADF0" opacity="1.000000" stroke="none" 
	d="
M432.760468,440.223755 
	C435.402588,440.250732 437.810181,440.561157 440.984131,440.930237 
	C443.154266,441.338715 444.558075,441.688507 445.961853,442.038269 
	C446.862671,443.161560 447.583069,444.520844 448.693573,445.369873 
	C455.881958,450.865784 454.819122,459.179596 455.816620,466.636658 
	C456.952301,475.126862 457.343689,483.718048 457.989563,492.270538 
	C458.070343,493.340240 457.730316,494.441681 457.364441,497.183014 
	C453.089630,492.632629 449.453125,489.235168 446.506348,485.318726 
	C445.687775,484.230804 446.723419,481.550903 447.244476,479.695801 
	C448.128021,476.549927 448.893341,473.543732 445.378174,471.075012 
	C444.986908,471.010895 444.973785,470.958099 444.973785,470.958099 
	C443.885437,469.980469 442.948181,468.638733 441.673584,468.109955 
	C439.731415,467.304199 437.555786,467.061005 435.236572,466.035675 
	C434.990448,465.316345 434.987030,465.140320 434.983643,464.964294 
	C436.655182,464.802704 438.328766,464.659393 439.997681,464.474274 
	C441.633453,464.292786 443.264465,464.068756 445.030457,463.516541 
	C446.030945,462.491394 447.440552,461.964508 447.679047,461.110565 
	C449.332855,455.189178 444.623657,447.151093 438.202515,445.294708 
	C431.387177,443.324341 424.622833,443.027588 418.489441,447.683716 
	C417.519653,448.419952 416.145813,448.623962 414.958801,449.074036 
	C414.571411,448.719177 414.184052,448.364288 413.796692,448.009430 
	C414.785583,446.709015 415.521820,445.025909 416.808502,444.176636 
	C421.547882,441.048401 426.657745,439.019958 432.760468,440.223755 
z"/>
<path fill="#EFFAFB" opacity="1.000000" stroke="none" 
	d="
M445.012695,471.019623 
	C445.292755,483.707642 439.692078,489.591980 427.990784,488.939545 
	C422.195892,488.616455 417.337677,484.266083 417.143280,479.225952 
	C416.965607,474.619080 421.499695,469.363098 427.049805,469.234558 
	C432.748627,469.102539 438.478027,470.287994 444.583923,470.927490 
	C444.973785,470.958099 444.986908,471.010895 445.012695,471.019623 
z"/>
<path fill="#49ABED" opacity="1.000000" stroke="none" 
	d="
M434.572968,464.917389 
	C434.987030,465.140320 434.990448,465.316345 434.991882,465.756744 
	C430.436890,466.810822 425.736847,467.131317 421.365906,468.501617 
	C415.009125,470.494446 413.641632,482.994598 418.869751,487.527618 
	C424.015045,491.988892 429.723602,491.676361 435.704468,490.121429 
	C437.209015,489.730225 438.708405,489.319275 440.751221,488.772614 
	C438.094696,494.032104 428.055145,497.729279 421.664764,495.605560 
	C414.387787,493.187256 406.600098,487.925293 408.157013,475.124695 
	C408.516632,473.224518 408.734222,472.091583 408.951782,470.958618 
	C408.951782,470.958618 408.958618,470.954559 408.946106,470.943420 
	C410.867126,470.138855 413.243927,469.812225 414.656586,468.470459 
	C420.467590,462.951019 427.159119,463.316010 434.572968,464.917389 
z"/>
<path fill="#6EAFD4" opacity="1.000000" stroke="none" 
	d="
M446.324432,442.021057 
	C444.558075,441.688507 443.154266,441.338715 441.381348,440.964691 
	C441.021423,440.455170 441.030609,439.969849 441.069244,439.119385 
	C441.801117,438.849823 442.503540,438.945404 443.557068,439.083252 
	C445.198212,439.878235 446.488312,440.630920 447.958405,441.658966 
	C447.654633,441.957489 447.170807,441.980652 446.324432,442.021057 
z"/>
<path fill="#6EAFD4" opacity="1.000000" stroke="none" 
	d="
M408.688538,471.048889 
	C408.734222,472.091583 408.516632,473.224518 408.157104,474.681061 
	C407.821564,474.996796 407.627991,474.988922 407.144104,474.961426 
	C406.875214,474.204346 406.896637,473.466949 406.954590,472.361389 
	C407.469177,471.708527 407.947235,471.423859 408.688538,471.048889 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M472.037231,482.401917 
	C475.569366,485.344727 474.210083,489.089966 472.521515,492.943268 
	C472.080994,489.656586 472.017853,486.258423 472.037231,482.401917 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M480.776154,438.746033 
	C481.060730,439.425293 481.042206,439.866821 480.996765,440.638489 
	C478.601135,440.388977 476.232452,439.809296 473.519409,439.154175 
	C475.607727,438.888580 478.040405,438.698425 480.776154,438.746033 
z"/>
<path fill="#67AED7" opacity="1.000000" stroke="none" 
	d="
M472.062073,451.367889 
	C474.932556,452.232452 474.613983,453.953247 472.489380,455.965668 
	C472.089874,454.631256 472.035339,453.209930 472.062073,451.367889 
z"/>
<path fill="#FAFCF5" opacity="1.000000" stroke="none" 
	d="
M141.985123,486.172974 
	C138.304031,486.151703 134.622925,486.130402 130.064102,486.074707 
	C126.732185,485.771973 123.619186,486.788330 123.642143,482.418213 
	C123.729408,465.805084 123.646645,449.190948 123.778679,432.578369 
	C123.787888,431.420135 125.082794,429.243134 125.690697,429.274414 
	C133.569443,429.679291 141.943207,428.885590 149.198120,431.336456 
	C167.378967,437.478485 167.995773,465.138123 158.589111,476.995850 
	C154.195129,482.534790 148.183502,484.327362 141.985123,486.172974 
z"/>
<path fill="#89A34B" opacity="1.000000" stroke="none" 
	d="
M142.066956,486.526215 
	C148.183502,484.327362 154.195129,482.534790 158.589111,476.995850 
	C167.995773,465.138123 167.378967,437.478485 149.198120,431.336456 
	C141.943207,428.885590 133.569443,429.679291 125.690697,429.274414 
	C125.082794,429.243134 123.787888,431.420135 123.778679,432.578369 
	C123.646645,449.190948 123.729408,465.805084 123.642143,482.418213 
	C123.619186,486.788330 126.732185,485.771973 129.614319,486.164185 
	C128.301804,486.985107 125.922653,488.742279 124.953888,488.158539 
	C122.940468,486.945496 120.344482,484.507599 120.320763,482.544952 
	C120.182373,471.095428 120.761543,459.638702 121.008736,448.182434 
	C121.120171,443.018219 120.953224,437.848297 121.041428,432.683197 
	C121.141418,426.827576 123.621696,425.311615 129.264648,426.470459 
	C132.951569,427.227600 136.866913,426.982117 140.680496,426.992920 
	C153.788315,427.030121 163.581726,434.792908 166.244843,447.340790 
	C166.381805,447.986084 166.675461,448.598114 166.950531,449.613403 
	C166.996964,454.688141 166.989044,459.375092 166.973389,464.527344 
	C165.995773,467.410492 165.025925,469.828308 164.011475,472.616882 
	C163.631927,474.062134 163.296967,475.136627 162.632355,476.619385 
	C160.878204,478.353027 159.453674,479.678436 158.029175,481.003845 
	C157.114990,484.449127 154.927841,486.036438 151.315140,486.040375 
	C149.995224,486.041840 148.676208,486.862946 147.173843,487.641541 
	C145.376862,487.608429 143.762833,487.243927 142.066956,486.526215 
z"/>
<path fill="#7CA421" opacity="1.000000" stroke="none" 
	d="
M158.392700,480.999084 
	C159.453674,479.678436 160.878204,478.353027 162.634247,476.979828 
	C161.562592,478.286133 160.159424,479.640228 158.392700,480.999084 
z"/>
<path fill="#85A33B" opacity="1.000000" stroke="none" 
	d="
M266.040344,447.552551 
	C265.887634,447.888641 265.721802,447.933868 265.300720,448.012329 
	C265.045502,447.327423 265.045502,446.609222 265.045502,445.891052 
	C265.241364,445.866394 265.437225,445.841766 265.633087,445.817108 
	C265.764465,446.298645 265.895813,446.780151 266.040344,447.552551 
z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
